// Auto-split from translations.ts — English is the default language and
// is statically imported by LanguageContext.
const dict = {
    // Navigation
    "nav.study": "Study",
    "nav.dashboard": "Dashboard",
    "nav.settings": "Settings",
    "nav.premium": "PRO",
    "nav.logout": "Logout",
    "nav.back": "Back",
    "nav.home": "Home",
    "nav.leaveQuizTitle": "Leave quiz?",
    "nav.leaveQuizDescription": "Your progress on this attempt will be lost. Are you sure?",
    "nav.stayInQuiz": "Continue",
    "nav.leaveQuiz": "Leave",
    
    // Auth
    "auth.login": "Login",
    "auth.register": "Sign Up",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirmPassword": "Confirm Password",
    "auth.firstName": "First Name",
    "auth.lastName": "Last Name",
    "auth.fullName": "Full Name",
    "auth.forgotPassword": "Forgot your password?",
    "auth.alreadyHaveAccount": "Already have an account?",
    "auth.noAccount": "Don't have an account?",
    "auth.resetPassword": "Reset Password",
    "auth.continuePrep": "Continue your MBLearn preparation",
    "auth.backToHome": "Back to home",

    "auth.signingIn": "Signing in...",
    "auth.createAccount": "Create Account",
    "auth.startPrep": "Start your MBLearn preparation",
    "auth.creatingAccount": "Creating account...",
    "auth.registerNow": "Sign up here",
    "auth.loginHere": "Log in",
    "auth.recoverPassword": "Recover Password",
    "auth.emailInstructions": "Enter your email and we'll send you instructions",
    "auth.emailPlaceholder": "your@email.com",
    "auth.sending": "Sending...",
    "auth.sendInstructions": "Send Instructions",
    "auth.backToLogin": "Back to login",
    "auth.showPassword": "Show password",
    "auth.hidePassword": "Hide password",
    "auth.newPassword": "New Password",
    "auth.enterNewPassword": "Enter your new password",
    "auth.passwordRequirements": "Must contain: uppercase, lowercase, number and special character (!@#$%...)",
    "auth.updating": "Updating...",
    "auth.updatePassword": "Update Password",
    "auth.invalidSession": "Invalid or expired session",
    "auth.invalidOrExpiredLink": "The recovery link is invalid or has expired",
    "auth.processing": "Processing...",
    "auth.errorCreating": "Error creating account",
    "auth.errorSending": "Error sending email",
    "auth.errorUpdating": "Error updating password",
    "auth.accountCreated": "Account created successfully! You can log in now.",
    "auth.errorSignIn": "Error signing in: ",
    "auth.welcomeBack": "Welcome back!",
    "auth.singleDeviceNotice": "Signing in will close your session on other devices.",
    "auth.displacedOtherDevice": "Your session on another device was closed.",
    "auth.sessionClosed": "Session closed successfully",
    "auth.errorSignOut": "Error signing out",
    "auth.resetEmailSent": "An email has been sent with instructions to reset your password",
    "auth.passwordUpdated": "Password updated successfully",
    "auth.rateLimitExceeded": "Too many failed attempts",
    "auth.rateLimitError": "Too many requests. Please wait a moment before trying again.",
    "auth.waitBeforeRetry": "Wait",
    "auth.tryAgainLater": "Please try again in 15 minutes",
    "auth.attemptsWarning": "Warning! Few attempts remaining",
    "auth.attemptsRemaining": "attempts remaining",
    "auth.accountTemporarilyLocked": "Account temporarily locked due to multiple failed attempts. Try again in 15 minutes.",
    "auth.accountLocked": "Account Locked",
    "auth.errorSigningIn": "Error signing in",
    "auth.connectionError": "Connection error. Please try again.",
    "auth.orContinueWith": "or continue with",
    "auth.signInWithApple": "Continue with Apple",
    "auth.logout": "Sign Out",
    "auth.logoutSuccess": "Logged out successfully",
    "auth.logoutError": "Error logging out",
    "auth.checkYourEmail": "Check your email!",
    "auth.resetLinkSent": "We sent you a link to reset your password. Check your inbox (and spam folder).",
    "auth.simplePasswordRequirements": "Minimum 6 characters",
    "auth.consentCheckbox": "By creating your account, you agree to our {terms} and acknowledge that you have read our {privacy}. MBLearn may collect and use information from your account, academic progress, results, exam attempts, in-app activity, last login, and usage metrics to operate the platform, provide support, improve the service, prevent fraud, and manage institutional programs where applicable.",
    "auth.consentRequired": "You must accept the terms and privacy policy to continue",
    "auth.activateAccount": "Activate your account",
    "auth.createPasswordToStart": "Create a password to start using MBLearn",
    "auth.activateAndContinue": "Activate account and continue",
    "auth.noticeAtCollection": "We may collect categories of data such as account information, identifiers, in-app activity, academic results, progress, service usage, and technical device information, and use them to operate MBLearn, provide support, manage institutional programs, maintain security, perform analytics, and improve the service.",
    "privacy.inAppNoticeTitle": "Privacy notice",
    "privacy.inAppNotice": "Your progress, results, exam attempts, last activity, and academic metrics may be visible to authorized MBLearn administrators and, where applicable, to institutional program administrators, solely for service operation, support, academic tracking, security, and platform improvement purposes. MBLearn does not display your password or full payment data to administrators.",
    
    // Roles
    "roles.student": "Student",
    "roles.therapist": "Therapist",
    "roles.admin": "Administrator",

    // Dashboard
    "dashboard.welcome": "Welcome",
    "dashboard.greeting": "Hello",
    "dashboard.student": "Student",
    "dashboard.subtitle": "Get ready for the MBLEx step by step",
    "dashboard.daysStreak": "Days in a row",
    "dashboard.dailyGoal": "Today's goal",
    "dashboard.startPracticing": "Start practicing",
    "dashboard.advancedModes": "Advanced Modes",
    "dashboard.yourBadges": "Your Badges & Achievements",
    "dashboard.actionStudyMode": "Study Mode",
    "dashboard.actionStudyModeDesc": "Practice with complete and detailed explanations.",
    "dashboard.actionQuizMode": "Quiz Mode",
    "dashboard.actionQuizModeDesc": "Practice with quick questions and answers.",
    "dashboard.actionFlashcards": "Flash Cards",
    "dashboard.actionFlashcardsDesc": "Quick cards to memorize key terms.",
    "dashboard.actionQuickQuiz": "Module Practice",
    "dashboard.actionQuickQuizDesc": "15 questions per level in each module to progress step by step.",
    "dashboard.actionReviewBank": "Review Bank",
    "dashboard.actionReviewBankDesc": "Repeat only the questions you failed.",
    "dashboard.actionExamSimulation": "MBLEx Exam Simulator",
    "dashboard.actionExamSimulationDesc": "Configurable practice: 50, 75, or 100 questions with adaptive difficulty.",
    "dashboard.actionRealExam": "Real Exam Mode (MBLEx)",
    "dashboard.actionRealExamDesc": "Fixed 100 questions • Welcome & demographics screen • Clean MBLEx-style experience.",
    "dashboard.actionVisualAnatomy": "Visual Anatomy Practice",
    "dashboard.actionVisualAnatomyDesc": "Recognize muscles, bones and structures in real body images.",
    "dashboard.continueWhereLeft": "Continue where you left off",
    "dashboard.level": "Level",
    "dashboard.resumeSession": "Resume session",
    "dashboard.youAreAt": "You are at",
    "dashboard.question": "Question",
    "dashboard.studyTimeToday": "Study time today",
    "dashboard.minutes": "min",
    "dashboard.recommendedForYou": "Recommended for you",
    
    // Coach / Next Best Action
    "coach.title": "Your next best action",
    "coach.critical": "You're in the critical zone. Practice {module} now.",
    "coach.weakArea": "Strengthen {module} ({pct}%).",
    "coach.inactive": "Get back to training today.",
    "coach.ready": "You're ready for a simulation.",
    "coach.go": "Start",
    "coach.badge.critical": "Urgent",
    "coach.badge.weak_area": "Weak area",
    "coach.badge.inactive": "Resume",
    "coach.badge.ready": "Level up",
    "coach.microGoal": "You need ~{n} more correct answers to reach 60%.",
    "coach.keepItUp": "Keep it up! Maintain your level.",
    "coach.quickSession": "A quick session will help you get back on track.",
    "coach.simulationHint": "Test everything you've learned with a full simulation.",
    "dashboard.completedModules": "You have completed {completed} of {total} modules",
    "dashboard.achievements": "Your badges and achievements",
    "dashboard.noAchievementsYet": "You haven't earned badges yet. Keep studying!",
    "dashboard.allAchievementsUnlocked": "You've unlocked all badges!",
    "dashboard.dailyConcept": "Key concept of the day",
    "dashboard.viewMoreConcepts": "View more concepts",
    "dashboard.support": "Support and feedback",
    "dashboard.privacy": "Privacy policy",
    "dashboard.terms": "Terms",
    "dashboard.examDate": "Exam Date",
    "dashboard.notDefined": "Not defined",
    "dashboard.setExamDate": "Set exam date",
    "dashboard.examScheduledFor": "Exam scheduled for",
    "dashboard.daysLeft": "days left",
    "dashboard.daysLeftUntilExam": "{daysLeft} days left until your exam",
    "dashboard.daysRemaining": "days remaining",
    "dashboard.examToday": "Today is the day!",
    "dashboard.examTomorrow": "Tomorrow is the exam!",
    "dashboard.examPassed": "Exam passed",
    "dashboard.studyNow": "Time to review everything you've learned!",
    "dashboard.studyOnTrackLight": "You're doing well. Study 20-30 min daily to keep pace.",
    "dashboard.studyOnTrack": "You're on track if you study 45-60 min daily.",
    "dashboard.studyIntensive": "Recommended: {minutes} min intensive study today.",
    "dashboard.generalProgress": "Overall Progress",
    "dashboard.overallProgress": "Overall Progress",
    "dashboard.moduleProgress": "Progress by Module",
    "dashboard.moduleMastery": "View your progress",
    "dashboard.masteredCount": "{mastered} of {total} mastered",
    "dashboard.basedOn30d": "Historical average ≥75%",
    "dashboard.completed": "Completed",
    "dashboard.mastery.needsReinforcement": "Needs reinforcement",
    "dashboard.mastery.inProgress": "In progress",
    "dashboard.mastery.mastered": "Mastered",
    "dashboard.continueStudying": "Continue Studying",
    "dashboard.takeQuiz": "Take a Quiz",
    "dashboard.generateQuestions": "Generate AI Questions",
    "dashboard.examSimulation": "Real Exam Simulator",
    "dashboard.studyMaterials": "Access your study materials",
    "dashboard.testKnowledge": "Test your knowledge",
    "dashboard.createAI": "Create questions with artificial intelligence",
    "dashboard.realExam": "100 questions under real MBLearn conditions",
    "dashboard.processing": "Processing...",
    "dashboard.activatePremium": "Activate PRO",
    "dashboard.redirectingToPayment": "Redirecting to payment...",
    "dashboard.noPaymentUrl": "Payment URL not available",
    "dashboard.verifyingPayment": "Verifying your payment...",
    "dashboard.paymentSuccess": "Payment successful! You now have PRO access",
    "dashboard.paymentProcessing": "Your payment is being processed...",
    "dashboard.paymentVerificationError": "Error verifying payment",
    "dashboard.yearlyPrice": "from $14.99/month",
    "dashboard.administration": "Administration",
    "dashboard.adminGenerateQuestions": "Generate questions",
    "dashboard.premiumFeature": "PRO",
    "dashboard.freeLevel": "Level 1 Free",
    "dashboard.firstTimeTitle": "Start your study path",
    "dashboard.firstTimeDesc": "Take your first diagnostic quiz and start saving your progress for the MBLEX exam.",
    "dashboard.start": "Start free",
    "dashboard.reportMBLExTitle": "Did you take the MBLEx?",
    "dashboard.reportMBLExDesc": "Share your result to help other students and improve the platform.",
    "dashboard.reportResult": "Report Result",
    "dashboard.firstTimeTitle.pro": "Enjoy your study path",
    "dashboard.firstTimeDesc.pro": "Your PRO access is active. Explore all modules and prepare for the MBLEX.",
    "dashboard.start.pro": "Start studying",
    "dashboard.includedInPro": "Included in your PRO plan",
    "dashboard.proBenefitsActive": "PRO benefits activated",
    "dashboard.activateSubscription": "Activate my subscription",
    "dashboard.attempts": "attempts",
    "dashboard.averageScore": "Average",
    "dashboard.bestScore": "Best",
    
    // Streak
    "streak.current": "Day streak",
    "streak.longest": "Best streak",
    
    // Quick Actions
    "quickActions.quickQuiz": "Quick Quiz",
    "quickActions.examMode": "Exam Mode",
    "quickActions.reviewBank": "Review Bank",
    "quickActions.reviewIncorrect": "Review incorrect questions",
    "quickActions.quickQuizTooltip": "Practice with short questions by category to assess your progress",
    "quickActions.average": "Average",
    "quickActions.best": "Best",
    "quickActions.passed": "Passed",
    "quickActions.attempts": "attempts",
    
    // Study Mode
    "study.flashcards": "Study Cards",
    "study.quiz": "Module Practice",
    "study.selectCategory": "Select a module",
    "study.back": "Back",
    "study.backToDashboard": "Back",
    "study.previous": "Previous",
    "study.next": "Next",
    "study.flip": "Flip",
    "study.question": "Question",
    "study.answer": "Answer",
    "study.noCards": "No cards available for this category",
    "study.backToCategories": "Back to Categories",
    "study.card": "Card",
    "study.of": "of",
    "study.studyCards": "Study Cards",
    "study.clickReveal": "Click to reveal answer",
    "study.clickQuestion": "Click to see question",
    "study.comingSoon": "This category will be available soon!",
    
    // Quiz Mode
    "quiz.score": "Score",
    "quiz.question": "Question",
    "quiz.submit": "Submit Answer",
    "quiz.nextQuestion": "Next Question",
    "quiz.finishQuiz": "Finish Quiz",
    "quiz.retry": "Retry",
    "quiz.tryAgain": "Try Again",
    "quiz.continueWithPending": "Continue with pending subjects",
    "quiz.continuePending": "Continue with pending subjects",
    "quiz.subjectCompleted": "Subject completed!",
    "quiz.saveFailed": "We couldn't save your attempt. Retry to record your pass.",
    "quiz.saveFailedRetry": "Retry save",
    "quiz.backToHome": "Back to Home",
    "quiz.correct": "Correct!",
    "quiz.wellDone": "Well done!",
    "quiz.incorrect": "Incorrect",
    "quiz.correctAnswerIs": "The correct answer is",
    "quiz.reviewAnswer": "Review the answer!",
    "quiz.completed": "Quiz Completed!",
    "quiz.finalScore": "Final Score",
    "quiz.youScored": "Your score",
    "quiz.outOf": "out of",
    "quiz.noQuiz": "No quiz available for this category",
    "quiz.selectAnswer": "Please select an answer",
    "quiz.pendingQuestionsTitle": "You have pending questions",
    "quiz.pendingQuestionsDesc": "You still have {{count}} question(s) to answer. Taking you to question {{question}} to finish them.",
    "quiz.explanation": "Explanation:",
    "quiz.showMore": "Show full explanation",
    "quiz.showLess": "Show less",
    "quiz.levelCompleted": "Level Completed!",
    "quiz.congratulations": "Congratulations!",
    "quiz.levelUnlocked": "You have unlocked level",
    "quiz.nextLevel": "Next Level",
    "quiz.backToModules": "Back to Modules",
    "quiz.keepStudying": "Keep studying!",
    "quiz.keepImproving": "You're improving!",
    "quiz.need70ToPass": "You need 70% or more to pass. Keep practicing and you'll get it!",
    "quiz.insightMissed": "You missed:",
    "quiz.insightHow": "MBLearn automatically reinforces the concepts you miss most so you can master them.",
    "quiz.unlockFull": "Unlock full access",
    "quiz.freeSessionDone": "Your free session is complete!",
    "quiz.freeSessionValue": "This is how MBLearn prepares you for the MBLEx — with adaptive practice and smart feedback.",
    "quiz.levelLocked": "Level Locked",
    "quiz.completeLevel": "Pass level",
    "quiz.toUnlock": "to unlock this level.",
    "quiz.lockedBaseline": "Complete your first Real Exam to unlock this level.",
    "quiz.lockedCompliance": "Complete last week's requirements to continue.",
    "quiz.lockedBaselineShort": "Complete your first Real Exam to unlock this level.",
    "quiz.lockedComplianceShort": "Complete last week's requirements to continue.",
    "quiz.lockedProgramNotStarted": "The program hasn't started yet.",
    "quiz.goToRealExam": "Go to Real Exam",
    "quiz.currentLevel": "Level",
    "quiz.levelPassed": "Level passed! (≥70%)",
    "quiz.nextLevelUnlocked": "Next level unlocked!",
    "quiz.tryAgainToPass": "You need 70% to pass. Try again!",
    "quiz.loadingResumed": "Loading your pending question…",
    "quiz.loadingQuestions": "Loading questions…",
    "quiz.premiumLevel": "PRO Level",
    "quiz.level1Free": "Only Anatomy Level 1 is free. To access other modules and levels you need a PRO subscription.",
    "quiz.withPremium": "With PRO you get:",
    "quiz.allLevels": "Access to all levels in all categories",
    "quiz.unlimitedExams": "Unlimited MBLearn exam simulations",
    "quiz.customCards": "Personalized study cards",
    "quiz.activatePremium": "Activate PRO",
    "quiz.goBack": "Go Back",
    "paywall.title": "Ready to pass the MBLEx?",
    "paywall.scoreMessage": "Your score was {score}%. Most people need between 70% and 75% to pass.",
    "paywall.description": "Unlock all 105 levels, real exam simulation, review bank, advanced analytics and AI explanations.",
    "paywall.feature1": "105 levels across 7 complete modules",
    "paywall.feature2": "Real MBLEx exam simulation",
    "paywall.feature3": "Smart review bank",
    "paywall.feature4": "AI explanations and advanced analytics",
    "paywall.cta": "Unlock full access – from $14.99/month",
    "paywall.maybeLater": "Maybe later",
    "quiz.free": "Free",
    "quiz.proIncluded": "Pro • Included with subscription",
    "quiz.nextRecommended": "Next recommended module:",
    "quiz.allModulesComplete": "You've completed all modules!",
    "quiz.tryGlobalExam": "Recommendation: review with Global Exam",
    "quiz.startExam": "Exam",
    "quiz.continueFromLevel": "Continue from",
    "quiz.continue": "Continue",
    "quiz.retrySave": "Retry save",
    "quiz.examSimSummary": "100 random questions under real exam conditions",
    "quiz.practiceByCategoryTitle": "Practice by Category",
    "quiz.practiceByCategoryDesc": "Select a module to practice questions by level",
    
    // Categories
    "category.anatomy": "Anatomy and Physiology",
    "category.kinesiology": "Kinesiology",
    "category.pathology": "Pathology, Contraindications and Special Populations",
    "category.benefits": "Benefits and Effects of Soft Tissue Manipulation",
    "category.assessment": "Client Assessment and Treatment Planning",
    "category.ethics": "Ethics, Boundaries, Laws and Regulations",
    "category.practice": "Guidelines for Professional Practice",
    "category.visual_anatomy_practice": "Visual Anatomy",
    "category.exam_simulation": "Real MBLearn Exam Simulation",
    // Short category names (mobile)
    "category.short.anatomy": "Anatomy",
    "category.short.kinesiology": "Kinesiology",
    "category.short.pathology": "Pathology",
    "category.short.assessment": "Assessment",
    "category.short.ethics": "Ethics",
    "category.short.benefits": "Soft Tissue",
    "category.short.practice": "Professional Practice",
    "category.short.exam_simulation": "MBLEx Simulator",
    "category.short.visual_anatomy_practice": "Visual Anatomy",
    
    // Admin Questions
    "admin.title": "MBLearn Question Generator",
    "admin.overallProgress": "Overall Progress",
    "admin.generateQuestions": "Generate Questions",
    "admin.category": "Category",
    "admin.batchSize": "Batch size",
    "admin.questions": "questions",
    "admin.categoryProgress": "Progress for this category",
    "admin.generate": "Generate",
    "admin.generating": "Generating questions...",
    "admin.generated": "Generated",
    "admin.newQuestions": "new questions for",
    "admin.allExist": "All generated questions already exist in the database",
    "admin.progress": "Progress",
    "admin.accessDenied": "Access denied. Only administrators can access.",
    "admin.verifyingPermissions": "Verifying permissions...",
    "admin.completed": "completed",
    "admin.selectCategory": "Select a category",
    
    // Admin Question Review
    "admin.questionReview.title": "Question Review",
    "admin.questionReview.subtitle": "Review questions by module and difficulty",
    "admin.questionReview.category": "Category",
    "admin.questionReview.difficulty": "Difficulty",
    "admin.questionReview.selectCategory": "Select category",
    "admin.questionReview.selectDifficulty": "Select difficulty",
    "admin.questionReview.loadQuestions": "Load Questions",
    "admin.questionReview.loading": "Loading...",
    "admin.questionReview.reviewing": "Reviewed:",
    "admin.questionReview.correct": "Correct",
    "admin.questionReview.confusing": "Mixed/Confusing",
    "admin.questionReview.incorrect": "Incorrect",
    "admin.questionReview.marked": "Question marked",
    "admin.questionReview.loaded": "Questions loaded",
    "admin.questionReview.questionsLoaded": "questions loaded",
    "admin.questionReview.error": "Error loading questions",
    "admin.questionReview.selectFilters": "Select category and difficulty",
    "admin.questionReview.noQuestions": "No questions available. Select filters and click Load.",
    
    // Difficulty
    "difficulty.easy": "Easy",
    "difficulty.medium": "Medium",
    "difficulty.hard": "Hard",
    
    // Settings
    "settings.title": "Settings",
    "quiz.translationNotAvailable": "⚠️ English translation not available for this question yet.",

    "topicDiagnostic.title": "Topic Diagnostic",
    "topicDiagnostic.description.default": "Identify exactly what you need to reinforce",
    "topicDiagnostic.description.topic": "Detailed subtopic analysis • {percent}% current",
    "topicDiagnostic.alert": "You have {count} topic(s) below the required 70%. Select a topic to see the subtopic breakdown.",
    "topicDiagnostic.correctCount": "{correct}/{total} correct",
    "topicDiagnostic.belowStandard": "{diff}% below standard",
    "topicDiagnostic.currentScore": "Current score",
    "topicDiagnostic.need70": "You need at least 70% to pass this topic on the MBLEx",
    "topicDiagnostic.noSubtopicData": "No subtopic data available. Practice more to get detailed diagnostics.",
    "topicDiagnostic.subtopicsToReinforce": "Subtopics to reinforce:",
    "topicDiagnostic.failedQuestions": "{count} questions failed",
    "topicDiagnostic.practice15": "Practice 15",
    "topicDiagnostic.viewFailed": "View failed",
    "topicDiagnostic.practiceAll": "Practice all {topic}",
    "topicDiagnostic.backToExam": "Back to exam",

    "mblexReport.title": "Report Your MBLEx Result!",
    "mblexReport.description": "Share your experience to help other students",
    "mblexReport.passed": "Did you pass the exam?",
    "mblexReport.yes": "Yes, I made it!",
    "mblexReport.no": "Not this time",
    "mblexReport.examDate": "Exam date",
    "mblexReport.attemptNumber": "Attempt number",
    "mblexReport.scorePercentage": "Approximate score (%)",
    "mblexReport.scoreOptional": "Optional - If you remember your score",
    "mblexReport.studyDuration": "Weeks of study",
    "mblexReport.studyHours": "Study hours per week",
    "mblexReport.weeksOption": "{weeks} weeks",
    "mblexReport.confidence": "Confidence level before exam",
    "mblexReport.confidenceLow": "Low",
    "mblexReport.confidenceHigh": "High",
    "mblexReport.mostHelpful": "What helped you most?",
    "mblexReport.mostHelpfulPlaceholder": "Select an option",
    "mblexReport.quizzes": "Category quizzes",
    "mblexReport.examSim": "Exam simulation",
    "mblexReport.studyMode": "Study mode",
    "mblexReport.reviewBank": "Review bank",
    "mblexReport.allFeatures": "All features",
    "mblexReport.additionalResources": "Did you use other resources?",
    "mblexReport.additionalResourcesPlaceholder": "E.g., books, videos, in-person classes...",
    "mblexReport.feedback": "Additional comments",
    "mblexReport.feedbackPlaceholder": "Share tips for future students...",
    "mblexReport.submit": "Submit Report",
    "mblexReport.submitting": "Submitting...",
    "mblexReport.successTitle": "Thank you for your report!",
    "mblexReport.successMessage": "Your experience will help other students.",
    "mblexReport.errorTitle": "Error submitting",
    "mblexReport.errorMessage": "Please try again.",
    "mblexReport.required": "This field is required",
    "settings.profile": "Profile",
    "settings.subscription": "Subscription",
    "settings.language": "Language",
    "settings.save": "Save Changes",
    "settings.saving": "Saving...",
    "settings.saved": "Settings saved",
    "settings.error": "Error saving settings",
    "settings.backToDashboard": "Back",
    "settings.manageAccount": "Manage your account and payments",
    "settings.stripePayments": "Stripe Payments",
    "settings.stripeDescription": "Connect Stripe to activate the MBLearn Pro annual plan and manage your subscriptions.",
    "settings.subscriptionStatus": "Subscription status",
    "settings.active": "Active",
    "settings.inactive": "Not active",
    "settings.renews": "Renews",
    "settings.activatePlan": "Activate Annual Plan – $39.99",
    "settings.processing": "Processing...",
    "settings.manageSubscription": "Manage Subscription",
    "settings.opening": "Opening...",
    "settings.tip": "Tip",
    "settings.stripeTip": "You will need your Stripe secret key to complete the connection. You can get it from your",
    "settings.stripeDashboard": "Stripe Dashboard",
    
    // Promo
    "promo.specialOffer": "Full PRO access from $14.99/month",
    "promo.price": "",
    "promo.wasBefore": "",
    "promo.validUntil": "Offer ends in",
    "promo.afterExpiry": "Cancel anytime.",
    "promo.claimNow": "Claim now!",
    "promo.days": "days",
    "promo.hours": "hrs",
    "promo.minutes": "min",
    "promo.seconds": "sec",
    "promo.limitedTime": "From $14.99/month — full access to all PRO content. Cancel anytime.",
    "promo.standardPrice": "Full PRO access",
    "promo.year": "year",
    "promo.yearShort": "mo",
    "promo.fromPrice": "from $14.99/mo",
    "promo.fromPriceShort": "$14.99+",
    "promo.viewProOffer": "View PRO offer",
    
    // Index/Home
    "home.login": "Login",
    "home.title": "MBLearn – Study resources for the MBLEX exam",
    "home.heroTitle": "MBLEx exam preparation — bilingual practice in Spanish and English",
    "home.heroTitleShort": "Prepare for your massage license (MBLEx)",
    "home.subtitle": "Practice with exam-style questions and study by module.",
    "home.heroSubtitle": "Practice with exam-style questions and study by module.",
    "home.heroFeature1": "Adaptive question selection (Smart-15)",
    "home.heroFeature2": "Automatic reinforcement of failed concepts",
    "home.heroFeature3": "Bilingual Spanish/English",
    "home.previewAlt": "MBLearn quiz preview",
    "home.previewCaption": "See exactly why you got it wrong — and fix it instantly",
    "home.benefitsTitle": "Why is MBLearn different?",
    "home.benefit.smart15": "Adaptive Smart-15 selection",
    "home.benefit.smart15Desc": "Get 15 smart questions adapted to your mistakes and progress.",
    "home.benefit.detect": "Automatically detects your mistakes",
    "home.benefit.detectDesc": "Our system identifies the concepts you struggle with the most.",
    "home.benefit.reinforce": "Reinforces the concepts you fail",
    "home.benefit.reinforceDesc": "Failed questions are automatically reinserted into your practice flow.",
    "home.benefit.bilingual": "Clear explanations in Spanish & English",
    "home.benefit.bilingualDesc": "Study in the language you prefer with an integrated AI tutor.",
    "home.startFree": "Start your free practice",
    "home.startPreparation": "Start your free practice →",
    "home.tryFreeQuestions": "Try 15 free practice questions →",
    "home.try20Questions": "Try 15 practice questions →",
    "home.studyCards": "study cards",
    "home.studyCardsDesc": "Visual cards to memorize concepts",
    "home.practiceQuizzes": "quizzes",
    "home.practiceQuizzesDesc": "Short practice quizzes",
    "home.coreModules": "core modules",
    "home.coreModulesDesc": "Complete modules to master topics",
    "home.databaseQuestions": "practice questions",
    "home.databaseQuestionsDesc": "Updated practice questions",
    "home.progressTracking": "Progress tracking",
    "home.stickyCtaMobile": "Start now – 15 practice questions",
    "home.heroDisclaimer": "MBLearn is an independent study platform. Not affiliated with, endorsed by, or approved by FSMTB. MBLEx® is a registered trademark of FSMTB and is used solely to describe exam preparation.",
    "home.howItWorks": "How it works",
    "home.step1Title": "Sign up and choose a module",
    "home.step1": "Sign up and choose a module",
    "home.step1Benefit": "30 seconds",
    "home.step2Title": "Practice with real questions",
    "home.step2": "Practice with real questions",
    "home.step2Benefit": "We identify weaknesses",
    "home.step3Title": "Track your daily progress",
    "home.step3": "Track your daily progress",
    "home.step3Benefit": "Adaptive study",
    "home.studyCategories": "Study Categories",
    "home.comingSoon": "Coming Soon",
    "home.anatomyDesc": "Learn the musculoskeletal system interactively.",
    "home.anatomyDescNew": "Learn the body with clear and easy images.",
    "home.kinesiologyDesc": "Understand movement and muscle function.",
    "home.kinesiologyDescNew": "Understand movement and muscle action.",
    "home.pathologyDesc": "Pathologies, contraindications and special populations.",
    "home.pathologyDescNew": "Master indications, contraindications and care.",
    "home.benefitsDesc": "Benefits and effects of soft tissue manipulation.",
    "home.assessmentDesc": "Client assessment and treatment planning.",
    "home.ethicsDesc": "Ethics, professional boundaries, laws and regulations.",
    "home.practiceDesc": "Guidelines for responsible professional practice.",
    "home.readyToStart": "Ready to start?",
    "home.ctaTitle": "Start your exam preparation today",
    "home.registerNow": "Register now and access all content to prepare for MBLearn",
    "home.ctaSubtitle": "Choose your path: free access or a 15-question trial session.",
    "home.startNow": "Start free →",
    "home.try20QuestionsShort": "Try 15 questions →",
    "home.ctaButton": "Try your first session free",
    "home.alreadyHaveAccount": "Already have an account?",
    "home.loginLink": "Log in",
    "home.createAccount": "Create account",
    "home.valueProp": "Unlock full access to pass your MBLEx — from $14.99/month",
    "home.cancelAnytime": "Cancel anytime",
    "home.pricingTitle": "Full PRO access",
    "home.pricingAmount": "from $14.99/month",
    "home.pricingDescription": "Includes all modules, advanced statistics and real simulations.",
    "home.proAccessTitle": "PRO Access from $14.99/month",
    "home.proFeatures": "40K+ questions · 7 modules · 100+ quizzes · exam simulator",
    "home.ctaSubtext": "No commitment. Start free and see how it works.",
    
    // Free Trial
    "trial.title": "Free trial",
    "trial.description": "Explore 15 free questions per module. Cancel anytime.",
    "trial.noCard": "7-day free trial. Cancel anytime. Just start studying.",
    
    // Onboarding
    "onboarding.title": "Welcome! Choose a category for your first free session",
    "onboarding.subtitle": "Experience 15 questions with instant feedback and automatic reinforcement.",
    "onboarding.freeSession": "15 free questions · Level 1",
    "onboarding.skip": "Go to dashboard →",
    
    // Trust Messages
    "trust.payments": "Secure payments with Stripe, Apple Pay and Google Pay. Cancel anytime from your portal.",
    
    // Disclaimer
    "disclaimer.title": "Important Notice",
    "disclaimer.text": "MBLearn is an independent study platform and is not affiliated with or endorsed by FSMTB. \"MBLEx®\" is a registered trademark used solely to describe exam preparation content and question style.",
    "disclaimer.textShort": "MBLearn is an independent platform and is not affiliated with FSMTB.",
    "disclaimer.readMore": "Read full notice",
    "disclaimer.payments": "Secure payments: Stripe, Apple Pay and Google Pay",
    
    // Pricing
    "pricing.planName": "MBLearn Annual",
    "pricing.planDescription": "Access to all modules, unlimited quizzes, saved progress and updates for 12 months. Limited time promotional price.",
    
    // FAQ
    "faq.title": "Frequently Asked Questions",
    "faq.q1": "What does MBLearn include?",
    "faq.a1": "Access to all 7 modules, thousands of updated questions, unlimited quizzes, study cards and progress tracking.",
    "faq.q2": "Can I try before paying?",
    "faq.a2": "Yes. You have 15 free questions per module, plus a 7-day free trial of full PRO access. Cancel anytime.",
    "faq.q3": "Is the content aligned with the MBLEX?",
    "faq.a3": "Yes. Topics and question style are aligned with the public MBLEX outline. We are not affiliated with FSMTB.",
    "faq.q4": "How do I cancel or renew?",
    "faq.a4": "Your subscription renews automatically according to your selected plan unless you cancel before the renewal date. You can cancel at any time from your Customer Portal.",
    "faq.q5": "Are there refunds?",
    "faq.a5": "We offer a full refund within the first 7 days if you haven't completed more than 2 quizzes per module.",
    "faq.q6": "Can I study in Spanish and English?",
    "faq.a6": "Yes. Change the language from the selector and your preference will be saved.",
    "faq.q7": "Does it work on mobile?",
    "faq.a7": "Yes. You can use it on your phone, tablet or computer; you can also add it to your home screen as an app.",
    
    // Footer
    "footer.copyright": "© 2025 MBLearn. All rights reserved.",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
    "footer.refunds": "Refund Policy",
    "footer.legal": "Legal notice",
    
    // Legal Pages
    "legal.privacy.title": "Privacy Policy",
    "legal.privacy.intro": "We protect your data. We only collect information necessary to create your account, process payments, and improve the service. We don't sell your information. You can request deletion of your data by writing to support.",
    "legal.terms.title": "Terms of Service",
    "legal.terms.intro": "By using MBLearn, you accept our fair use rules, prohibition on content redistribution, and liability limits. The service is provided \"as is\" and may be updated without prior notice.",
    "legal.refunds.title": "Refund Policy",
    "legal.refunds.intro": "Full refund within 7 days if you haven't completed more than two quizzes per module. To request it, contact us with your account email.",
    
    // Welcome Email
    "welcome.subject": "Welcome to MBLearn! Your study plan starts today",
    "welcome.body": "Thanks for joining. 1) Take the 5-min diagnostic quiz. 2) Check your weak areas on the dashboard. 3) Schedule 20–30 minutes daily. Reply if you need help.",
    
    "home.previewAvailable": "Preview Available",
    "home.study": "Study",
    "home.quiz": "Quiz",
    
    // Module Labels
    "module.anatomy": "Anatomy and Physiology",
    "module.kinesiology": "Kinesiology",
    "module.pathology": "Pathology, Contraindications and Special Populations",
    "module.benefits": "Benefits and Effects of Soft Tissue Manipulation",
    "module.assessment": "Client Assessment and Treatment Planning",
    "module.ethics": "Ethics, Boundaries, Laws and Regulations",
    "module.practice": "Guidelines for Professional Practice",
    "module.exam_simulation": "Exam Mode",
    "module.real_exam": "Real Exam Mode (MBLEx)",
    
    // Messages
    "message.loadingDashboard": "Loading dashboard...",
    "message.errorLoading": "Error loading data",
    "message.paymentError": "Error processing payment. Try again.",
    "message.paymentErrorAdmin": "Error processing payment. Please contact the administrator.",
    "message.paymentPending": "Payment configuration pending",
    "message.billingPortalError": "Error opening billing portal.",
    "message.profileUpdated": "Profile updated successfully",
    "message.errorUpdating": "Error updating",
    "message.passwordUpdated": "Password updated successfully",
    "message.colorsApplied": "Colors applied successfully",
    "message.errorLoadingQuestions": "Error loading questions",
    
    // Settings Tabs
    "settings.tabProfile": "Profile",
    "settings.tabNotifications": "Notifications",
    "settings.tabSecurity": "Security",
    "settings.tabPremium": "PRO",
    "settings.tabAppearance": "Appearance",
    "settings.tabPrivacy": "Privacy",
    
    // Settings - Profile
    "settings.personalInfo": "Personal Information",
    "settings.email": "Email",
    "settings.emailCannotChange": "Email cannot be changed",
    "settings.phone": "Phone",
    "settings.examDate": "Exam Date",
    "settings.selectExamDate": "Select your exam date",
    "settings.examDateDesc": "This date will help you plan your study and see how many days you have left",
    "settings.saveChanges": "Save Changes",
    "settings.savingChanges": "Saving...",
    
    // Settings - Notifications
    "settings.notificationPreferences": "Notification Preferences",
    "settings.emailNotifications": "Email Notifications",
    "settings.emailNotificationsDesc": "Receive updates about your progress, study reminders, and important notifications related to your account",
    "settings.smsNotifications": "Text Messages (SMS)",
    "settings.smsNotificationsDesc": "Receive critical alerts via text message, such as exam reminders and urgent account updates",
    "settings.newsletterSub": "Massage Newsletter",
    "settings.newsletterSubDesc": "Receive weekly study tips, new practice questions, and updates about platform improvements",
    "settings.messageSoundLabel": "Message sound",
    "settings.messageSoundDesc": "Play a sound when a new message arrives",
    "settings.savePreferences": "Save Preferences",
    "settings.privacyNotice": "See our {privacy} and {terms} for more information about how we handle your data.",
    "settings.privacyPolicy": "Privacy Policy",
    "settings.termsOfService": "Terms of Service",

    // Settings - Privacy
    "settings.privacy": "Privacy",
    "settings.aiPrivacy": "MBLearn AI Privacy",
    
    // Settings - Security
    "settings.changePassword": "Change Password",
    "settings.newPassword": "New Password",
    "settings.newPasswordPlaceholder": "Minimum 8 characters, uppercase, lowercase and number",
    "settings.passwordRequirement": "Password must be at least 8 characters with uppercase, lowercase and number",
    "settings.confirmPassword": "Confirm Password",
    "settings.confirmPasswordPlaceholder": "Repeat the new password",
    "settings.updating": "Updating...",
    "settings.updatePassword": "Change Password",
    
    // Settings - Appearance
    "settings.appearance": "Appearance",
    "settings.theme": "Application Theme",
    "settings.themeDescription": "Automatic mode switches to dark from 6 PM to 6 AM",
    "settings.themeLight": "Light",
    "settings.themeDark": "Dark",
    "settings.themeAuto": "Automatic",
    "settings.languageSaved": "Language saved successfully",
    
    // App Update
    "update.newVersionAvailable": "We updated MBLearn. Press update to continue.",
    "update.updating": "Updating app…",
    "update.clearingCache": "Updating app…",
    "update.updatingApp": "Applying improvements…",
    "update.reloading": "Reloading…",
    "update.pendingProtected": "An update is pending. It will be applied when you finish your current session.",
    "update.improvementsAvailable": "Improvements and fixes are available.",
    "update.updateNow": "Update now",
    "update.update": "Update",

    // State Preservation
    "state.progressSaved": "Progress saved",
    "state.progressRestored": "Progress restored",
    "state.autoSaving": "Auto-saving...",
    "state.sessionRestored": "Session restored",
    "state.continueFromWhereLeft": "Continuing where you left off",
    "exam.resuming": "Resuming practice exam",
    "settings.customizeColors": "Customize Colors",
    "settings.customizeDesc": "Customize the application colors",
    "settings.primaryColor": "Primary Color",
    "settings.accentColor": "Accent Color",
    "settings.applyColors": "Apply Colors",
    "settings.applyingColors": "Applying...",
    "settings.resetDefaults": "Reset Defaults",
    
    // Exam Simulation
    "exam.loading": "Loading exam...",
    "exam.simulation": "MBLearn Exam Simulation",
    "exam.conditions": "This exam simulates real MBLearn conditions with:",
    "exam.questions": "questions",
    "exam.timeLimit": "120 minutes time limit",
    "exam.distribution": "Topic distribution based on real exam:",
    "exam.startExam": "Start Exam",
    "exam.congratulations": "Congratulations! You Passed",
    "exam.didNotPass": "You Did Not Pass",
    "exam.of": "of",
    "exam.correctAnswers": "correct answers",
    "exam.passRequirement": "70% required to pass MBLearn",
    "exam.backToQuiz": "Back to Quiz",
    "exam.tryAgain": "Try Again",
    "exam.question": "Question",
    "exam.previous": "Previous",
    "exam.next": "Next",
    "exam.finishExam": "Finish Exam",
    "exam.adaptiveDifficulty": "Adaptive Difficulty",
    "exam.examNumber": "Exam #{num}",
    "exam.baseLevelDesc": "Base level • Difficulty increases 15% after each exam",
    "exam.difficultyIncreaseDesc": "Difficulty +{percent}% • New questions prioritized",
    "exam.examLength": "Exam Length",
    "exam.timeMinutes": "Time: {minutes} minutes",
    "exam.reviewRecommendations": "Review Recommendations",
    "exam.basedOnAnswers": "Based on your answers, we suggest reviewing:",
    "exam.priorityHigh": "High Priority",
    "exam.priorityMedium": "Medium Priority",
    "exam.priorityLow": "Low Priority",
    "exam.urgentReview": "Urgent review recommended",
    "exam.needsReinforce": "You need to reinforce this topic",
    "exam.goodMastery": "Good mastery, review to maintain",
    "exam.questionsStats": "{wrong} of {total} questions ({percent}% incorrect)",
    "exam.nextExamDifficulty": "Next exam: Difficulty +15% ({percent}% total)",
    "exam.translationPending": "(Translation pending)",
    
    // PWA Installation
    "pwa.install": "Download App",
    "pwa.installed": "App Installed",
    "pwa.installNow": "Install Now",
    "pwa.iosInstructions.title": "To install on iOS/iPad:",
    "pwa.iosInstructions.step1": "Tap the share button",
    "pwa.iosInstructions.step1b": "in the Safari toolbar",
    "pwa.iosInstructions.step2": "Select 'Add to Home Screen'",
    "pwa.iosInstructions.step3": "Confirm and the app will appear on your home screen",
    "pwa.androidInstructions.title": "To install on Android/PC:",
    "pwa.androidInstructions.step1": "Click the 'Install' button below",
    "pwa.androidInstructions.step2": "Follow the on-screen instructions to complete installation",
    "pwa.ios.needSafari": "You need Safari to install this app on iOS/iPad",
    "pwa.ios.downloadSafari": "Download Safari",
    "pwa.ios.tapToAppStore": "Tap here to go to the App Store",
    "pwa.ios.scanQR": "Scan this QR code with your iPhone/iPad",
    "pwa.ios.copyLinkManually": "Or copy the link manually:",
    "pwa.ios.copyAppLink": "Copy app link",
    "pwa.ios.linkCopied": "✓ Link copied",
    "pwa.ios.inSafari": "You're in Safari. Follow these steps to install:",
    "pwa.ios.tapShareButton": "Tap the share button",
    "pwa.ios.shareLocation": "Find it in the top-right or bottom Safari toolbar (arrow pointing up icon)",
    "pwa.ios.scrollDown": "Scroll DOWN in the menu that opens",
    "pwa.ios.scrollDownHint": "The option you're looking for isn't visible at first, you need to scroll down",
    "pwa.ios.addToHomeScreen": "Tap \"Add to Home Screen\"",
    "pwa.ios.addToHomeScreenHint": "It has a square icon with a + sign",
    "pwa.ios.confirmInstall": "Confirm the installation",
    "pwa.ios.willAppearOnHome": "The app will appear as an icon on your home screen",
    "pwa.android.installFromChrome": "Install the app from Chrome menu",
    "pwa.android.tapThreeDots": "Tap the 3 dots in the upper right corner",
    "pwa.android.chromeMenu": "Chrome options menu (⋮)",
    "pwa.android.findInstallOption": "Look for \"Install app\" or \"Add to Home screen\"",
    "pwa.android.mayAppearAs": "It may appear as \"Install app\" or \"Add to Home screen\"",
    "pwa.android.confirmInstall": "Confirm the installation",
    "pwa.android.willAppearOnHome": "The app will appear as an icon on your home screen",
    "pwa.android.playStoreComingSoon": "Google Play: Coming soon",
    "pwa.android.getOnGooglePlay": "Get it on Google Play",
    "pwa.android.tip": "Tip:",
    "pwa.android.tipContent": "If you don't see the install option, you may have already installed it or your browser may need updating.",
    
    // Admin Users
    "adminUsers.title": "User Management",
    "adminUsers.backToQuestions": "Back to Questions",
    "adminUsers.totalUsers": "Total Users",
    "adminUsers.verified": "Verified",
    "adminUsers.unverified": "Unverified",
    "adminUsers.active24h": "Active (24h)",
    "adminUsers.active7d": "Active (7d)",
    "adminUsers.searchPlaceholder": "Search by email, name, ID...",
    "adminUsers.clearSearch": "Clear search",
    "adminUsers.recalculateProgress": "Recalculate Progress",
    "adminUsers.refresh": "Refresh",
    "adminUsers.logout": "Logout",
    "adminUsers.cleanNoEmail": "Clean No Email",
    "adminUsers.viewStats": "View Stats",
    "adminUsers.blockUser": "Block",
    "adminUsers.unblockUser": "Unblock",
    "adminUsers.grantFreeAccess": "Grant Free Access",
    "adminUsers.revokeFreeAccess": "Revoke Free Access",
    "adminUsers.deleteAccount": "Delete Account",
    "adminUsers.role": "Role",
    "adminUsers.subscription": "Subscription",
    "adminUsers.language": "Language",
    "adminUsers.examDate": "Exam Date",
    "adminUsers.lastSignIn": "Last Sign In",
    "adminUsers.blocked": "Blocked",
    "adminUsers.freeAccess": "Free Access",
    "adminUsers.deleteConfirmTitle": "Delete user?",
    "adminUsers.deleteConfirmDesc": "This will permanently delete user",
    "adminUsers.deleteConfirmActions": "This action cannot be undone",
    "adminUsers.deleteSuccess": "User deleted successfully",
    "adminUsers.deleteError": "Error deleting user",
    "adminUsers.progressRecalculated": "Progress recalculated",
    "adminUsers.usersUpdated": "users updated",
    "adminUsers.progressRecalculateError": "Error recalculating progress",
    "adminUsers.riskHigh": "High",
    "adminUsers.riskMedium": "Medium",
    "adminUsers.riskLow": "Low",
    "adminUsers.riskAll": "All",
    "adminUsers.masteryWeak": "Weak",
    "adminUsers.masteryProgress": "In Progress",
    "adminUsers.masteryDominated": "Mastered",
    "adminUsers.filterRisk": "Risk",
    "adminUsers.filterActivity": "Activity",
    "adminUsers.filterAccuracy": "Accuracy",
    "adminUsers.activeRecent": "Active 7d",
    "adminUsers.inactive": "Inactive",
    "adminUsers.colName": "Name",
    "adminUsers.colLastActivity": "Last Activity",
    "adminUsers.colAccuracy30d": "Accuracy 30d",
    "adminUsers.colAttempts30d": "Attempts 30d",
    "adminUsers.colStudyTime30d": "Time 30d",
    "adminUsers.colMastery": "Mastery",
    "adminUsers.colRisk": "Risk",
    "adminUsers.colAction": "Action",
    "adminUsers.accuracy7d": "Accuracy 7d",
    "adminUsers.accuracy30d": "Accuracy 30d",
    "adminUsers.attempts30d": "Attempts 30d",
    "adminUsers.studyTime30d": "Time 30d",
    "adminUsers.lastSimulation": "Last Simulation",
    "adminUsers.trend": "Trend",
    "adminUsers.weakAreas": "Weak Areas",
    "adminUsers.viewFullStats": "View full stats",
    "adminUsers.recalculate": "Recalculate stats",
    "adminUsers.noData": "No data",
    "adminUsers.never": "Never",
    "adminUsers.page": "Page",
    "adminUsers.of": "of",
    "adminUsers.showingUsers": "Showing",
    "adminUsers.users": "users",

    // Admin Content Analysis
    "adminContent.title": "MBLEx Content Analysis",
    "adminContent.analyzeContent": "Analyze Content",
    "adminContent.analyzing": "Analyzing...",
    "adminContent.checkUpdates": "Check MBLEx Updates",
    "adminContent.checking": "Checking...",
    "adminContent.currentVersion": "Current Version",
    "adminContent.lastCheck": "Last Check",
    "adminContent.noCheck": "No checks",
    "adminContent.contentSummary": "Content Summary",
    "adminContent.totalQuestions": "Total Questions",
    "adminContent.coverageAnalysis": "Coverage Analysis by Category",
    "adminContent.official": "Official",
    "adminContent.current": "Current",
    "adminContent.difference": "Difference",
    "adminContent.status": "Status",
    "adminContent.aligned": "Aligned",
    "adminContent.over": "Over",
    "adminContent.under": "Needs",
    "adminContent.questionsNeeded": "Questions Needed",
    "adminContent.recommendations": "Recommendations",
    "adminContent.highPriority": "High",
    "adminContent.mediumPriority": "Medium",
    "adminContent.lowPriority": "Low",
    "adminContent.analysisComplete": "Analysis complete",
    "adminContent.analysisError": "Error analyzing content",
    "adminContent.updateCheckComplete": "Check complete",
    "adminContent.noUpdatesFound": "No updates found",
    "adminContent.updatesFound": "MBLEx content updates found",

    // Recommendations Panel
    "recommendations.title": "Personalized Recommendations",
    "recommendations.description": "Based on your performance and areas for improvement",
    "recommendations.update": "Update",
    "recommendations.generate": "Generate Recommendations",
    "recommendations.noRecommendations": "Complete some quizzes to receive personalized recommendations",
    "recommendations.weakAreas": "Weak areas:",
    "recommendations.suggestedLevels": "Suggested levels:",
    "recommendations.startPractice": "Start Practice",
    "recommendations.priority.critical": "Critical",
    "recommendations.priority.veryHigh": "Very High",
    "recommendations.priority.high": "High",
    "recommendations.priority.medium": "Medium",
    "recommendations.priority.low": "Low",

    // Question Report Dialog
    "report.title": "Help us improve this question",
    "report.button": "Report",
    "report.subtitle": "Describe the problem. Your feedback helps us correct errors and improve the question bank.",
    "report.typeLabel": "Type of problem *",
    "report.optionIncorrectAnswer": "Correct answer seems wrong",
    "report.optionAmbiguous": "Question is ambiguous or confusing",
    "report.optionBadExplanation": "Explanation is unclear or incorrect",
    "report.optionTranslation": "Spelling or translation error",
    "report.optionOther": "Other (specify in comment)",
    "report.commentLabel": "Additional comment",
    "report.commentOptional": "(optional)",
    "report.commentPlaceholder": "Explain the problem in detail to help us resolve it...",
    "report.cancel": "Cancel",
    "report.submit": "Send report",
    "report.submitting": "Sending...",

    // 404 Not Found
    "notFound.title": "404",
    "notFound.message": "Oops! Page not found",
    "notFound.returnHome": "Return to Home",
    
    // Common
    "common.loading": "Loading...",
    "common.error": "Error",
    "common.success": "Success",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.save": "Save",
    "common.close": "Close",
    "common.retry": "Retry",
    "common.retrying": "Retrying...",
    "common.back": "Back",
    "common.loadError": "Could not load data. Check your connection and try again.",
    "common.excellentWork": "Excellent work!",
    "common.goToPractice": "Go to practice",
    
    // TTS (Text-to-Speech)
    "tts.listen": "Listen",
    "tts.pause": "Pause",
    "tts.resume": "Resume",
    "tts.stop": "Stop",
    "tts.notSupported": "Your browser doesn't support audio",
    
    // Recruitment - Top Students
    "recruitment.topStudents": "Top Students / Recruitment Candidates",
    "recruitment.studentsOf": "of",
    "recruitment.students": "students",
    "recruitment.filters": "Filters",
    "recruitment.exportCsv": "Export CSV",
    "recruitment.search": "Search",
    "recruitment.searchPlaceholder": "Name or email...",
    "recruitment.minScore": "Min. score (%)",
    "recruitment.minHours": "Min. study hours",
    "recruitment.minModules": "Modules compl. (%)",
    "recruitment.minAnatomy": "Min. anatomy (%)",
    "recruitment.minSessions": "Min. sessions/week",
    "recruitment.clearFilters": "Clear filters",
    "recruitment.totalStudents": "Total students",
    "recruitment.markedCandidates": "Marked candidates",
    "recruitment.scoreAbove75": "Score ≥75%",
    "recruitment.modulesAbove60": "Modules ≥60%",
    "recruitment.student": "Student",
    "recruitment.score": "Score",
    "recruitment.anatomy": "Anatomy",
    "recruitment.hours": "Hours",
    "recruitment.modules": "Modules",
    "recruitment.sessionsWeek": "Sessions/Week",
    "recruitment.exams": "Exams",
    "recruitment.action": "Action",
    "recruitment.marked": "Marked",
    "recruitment.mark": "Mark",
    "recruitment.candidate": "Candidate",
    "recruitment.noStudentsFound": "No students found with the applied filters.",
    "recruitment.candidateRemoved": "Candidate removed",
    "recruitment.candidateMarked": "Candidate marked",
    "recruitment.studentNotCandidate": "The student is no longer marked as a candidate.",
    "recruitment.studentMarkedCandidate": "The student has been marked as a recommended candidate.",
    "recruitment.errorUpdatingCandidate": "Could not update candidate status.",
    "recruitment.errorLoadingStudents": "Could not load students.",
    
    // Recruitment - Settings
    "recruitment.settings": "Recruitment Settings",
    "recruitment.settingsDesc": "Configure recruitment criteria and announcement",
    "recruitment.saveChanges": "Save changes",
    "recruitment.saving": "Saving...",
    "recruitment.announcementConfig": "Announcement Configuration",
    "recruitment.announcementConfigDesc": "Configure the announcement content that qualified students will see",
    "recruitment.announcementEnabled": "Announcement enabled",
    "recruitment.announcementEnabledDesc": "Show announcement to students who meet the criteria",
    "recruitment.announcementTitle": "Announcement title",
    "recruitment.announcementText": "Announcement text",
    "recruitment.announcementButton": "Button text",
    "recruitment.qualificationCriteria": "Qualification Criteria",
    "recruitment.qualificationCriteriaDesc": "Define the minimum requirements for a student to see the announcement",
    "recruitment.minAvgScore": "Minimum average score (%)",
    "recruitment.minAvgScoreDesc": "Average score across all quizzes",
    "recruitment.minAnatomyScore": "Minimum anatomy score (%)",
    "recruitment.minAnatomyScoreDesc": "Specific score in the Anatomy module",
    "recruitment.minStudyHours": "Minimum study hours",
    "recruitment.minStudyHoursDesc": "Total accumulated study hours",
    "recruitment.minModulesCompleted": "Minimum modules completed (%)",
    "recruitment.minModulesCompletedDesc": "Percentage of modules completed at 100%",
    "recruitment.minWeeklySessions": "Minimum sessions per week",
    "recruitment.minWeeklySessionsDesc": "Average weekly study frequency",
    "recruitment.announcementPreview": "Announcement preview",
    "recruitment.settingsSaved": "Saved",
    "recruitment.settingsSavedDesc": "Settings have been saved successfully.",
    "recruitment.errorSavingSettings": "Could not save settings.",
    "recruitment.errorLoadingSettings": "Could not load settings.",
    "recruitment.noSettingsFound": "No settings found.",
    
    // Recruitment - Therapy Applicants
    "recruitment.therapyApplicants": "Therapy Applicants",
    "recruitment.totalApplications": "total applications",
    "recruitment.createApplication": "Create application",
    "recruitment.pending": "Pending",
    "recruitment.approved": "Approved",
    "recruitment.rejected": "Rejected",
    "recruitment.applicant": "Applicant",
    "recruitment.statePhone": "State/Phone",
    "recruitment.license": "License",
    "recruitment.certifications": "Certifications",
    "recruitment.studyStats": "Study Stats",
    "recruitment.status": "Status",
    "recruitment.date": "Date",
    "recruitment.yes": "Yes",
    "recruitment.no": "No",
    "recruitment.studying": "Studying",
    "recruitment.lymphatic": "Lymphatic",
    "recruitment.postOp": "Post-op",
    "recruitment.none": "None",
    "recruitment.viewDetails": "View details",
    "recruitment.noApplicationsYet": "No applications yet.",
    "recruitment.applicationDetails": "Application Details",
    "recruitment.applicantInfo": "Applicant Information",
    "recruitment.name": "Name",
    "recruitment.email": "Email",
    "recruitment.phone": "Phone",
    "recruitment.state": "State",
    "recruitment.applicationDate": "Application date",
    "recruitment.currentStatus": "Current status",
    "recruitment.certificationsExperience": "Certifications and Experience",
    "recruitment.massageLicense": "Massage license",
    "recruitment.studyingForLicense": "Studying for license",
    "recruitment.lymphaticDrainage": "Lymphatic drainage",
    "recruitment.postOpDrainage": "Post-op drainage",
    "recruitment.previousExperience": "Previous experience",
    "recruitment.additionalDetails": "Additional details",
    "recruitment.mblearnStudyStats": "MBLearn Study Statistics",
    "recruitment.notLinkedAccount": "This applicant is not linked to an MBLearn account or has no recorded statistics.",
    "recruitment.avgScore": "Average Score",
    "recruitment.studyHours": "Study Hours",
    "recruitment.sessionsPerWeek": "Sessions per week",
    "recruitment.completedExams": "Completed exams",
    "recruitment.documents": "Documents",
    "recruitment.identification": "Identification",
    "recruitment.viewDocument": "View document",
    "recruitment.selfie": "Selfie",
    "recruitment.adminNotes": "Admin internal notes",
    "recruitment.addNotesPlaceholder": "Add internal notes about this candidate...",
    "recruitment.saveNotes": "Save notes",
    "recruitment.changeStatus": "Change Status",
    "recruitment.pendingStatus": "Pending",
    "recruitment.approve": "Approve",
    "recruitment.reject": "Reject",
    "recruitment.createManualApplication": "Create Manual Application",
    "recruitment.fullName": "Full name",
    "recruitment.licenseNumber": "License number",
    "recruitment.experience": "Experience",
    "recruitment.internalNote": "Internal note",
    "recruitment.notesPlaceholder": "Notes visible only to administrators...",
    "recruitment.experiencePlaceholder": "Years of experience, previous workplaces, etc.",
    "recruitment.certificationsPlaceholder": "Lymphatic drainage, Post-op drainage, etc.",
    "recruitment.cancel": "Cancel",
    "recruitment.saveApplication": "Save application",
    "recruitment.hasMassageLicense": "Has massage license?",
    "recruitment.requiredFields": "Required fields",
    "recruitment.requiredFieldsDesc": "Please complete name, email and phone.",
    "recruitment.applicationCreated": "Application created",
    "recruitment.applicationCreatedDesc": "The candidate has been successfully registered.",
    "recruitment.errorCreatingApplication": "Could not create the application.",
    "recruitment.statusUpdated": "Status updated",
    "recruitment.statusApproved": "The application has been marked as approved.",
    "recruitment.statusRejected": "The application has been marked as rejected.",
    "recruitment.statusPending": "The application has been marked as pending.",
    "recruitment.errorUpdatingStatus": "Could not update status.",
    "recruitment.notesSaved": "Notes saved",
    "recruitment.notesSavedDesc": "Notes have been updated.",
    "recruitment.errorSavingNotes": "Could not save notes.",
    "recruitment.errorLoadingApplications": "Could not load applications.",
    
    // Recommendations
    "recommendations.critical": "Critical",
    "recommendations.needsUrgentAttention": "Needs urgent attention",
    "recommendations.recoverArea": "Recover area",
    "recommendations.completed": "completed",
    "recommendations.errors": "Errors",
    "recommendations.youMissedQuestions": "You missed {n} questions recently",
    "recommendations.reviewMistakes": "Review mistakes",
    "recommendations.continue": "Continue",
    "recommendations.level": "Level",
    "recommendations.resumeSession": "Resume session",
    "recommendations.dailyMiniExam": "Daily Mini Exam",
    "recommendations.tryQuickQuestions": "Try 5–10 quick questions",
    "recommendations.startMiniExam": "Start mini exam",
    "recommendations.today": "Today",

    // Achievements
    "achievements.title": "Achievements",
    "achievements.viewAll": "View all",
    "achievements.locked": "Locked",
    "achievements.unlocked": "Unlocked",
    "achievements.achievementUnlocked": "Achievement Unlocked!",
    "achievements.progress": "Progress",

    // Review Bank
    "reviewBank.title": "Review Bank",
    "reviewBank.subtitle": "Review the questions you failed",
    "reviewBank.noQuestions": "Congratulations! You have no questions pending for review.",
    "reviewBank.practiceMore": "Practice More",
    "reviewBank.questionsToReview": "questions to review",
    "reviewBank.clearMastered": "Clear Mastered",
    "reviewBank.startReview": "Start Review",

    // News Card
    "news.title": "News",
    "news.subtitle": "Latest MBLearn updates",
    "news.readMore": "Read more",
    "news.dismiss": "Dismiss",
    
    // Settings - PRO
    "settings.proPlan": "PRO Plan",
    "settings.proActive": "Your PRO plan is active",
    "settings.proExpires": "Expires on",
    "settings.proRenews": "Renews on",
    "settings.verifyRestore": "Verify/Restore PRO",
    "settings.verifying": "Verifying...",
    "settings.proVerified": "PRO verified successfully",
    "settings.proNotFound": "No active subscription found",
    "settings.proVerifyError": "Error verifying PRO",

    // Text Scale
    "settings.textScale": "Text Size",
    "settings.textScaleNormal": "Normal",
    "settings.textScaleLarge": "Large",
    "settings.textScaleExtraLarge": "Extra Large",
    
    // Offline Mode
    "offline.title": "Offline Mode",
    "offline.available": "Content available offline",
    "offline.downloading": "Downloading content...",
    "offline.ready": "Ready to study offline",
    "offline.syncRequired": "Sync required",
    "offline.lastSync": "Last sync",
    
    // Version Info
    "version.current": "Current version",
    "version.update": "Update available",
    "version.upToDate": "You're up to date",
    "version.title": "Version Info",
    "version.subtitle": "App version and system status",
    "version.appVersion": "App Version:",
    "version.serviceWorker": "Service Worker:",
    "version.swVersion": "SW Version:",
    "version.browser": "Browser:",
    "version.statusActive": "Active",
    "version.statusUpdating": "Updating",
    "version.statusInactive": "Inactive",
    "version.checkUpdates": "Check for Updates",
    "version.checking": "Checking...",
    
    // Progress Card
    "progress.yourProgress": "Your Progress",
    "progress.badges": "badges",
    "progress.dayStreak": "Day Streak",
    "progress.todaysGoal": "Today's Goal",
    "progress.overallProgress": "Overall Progress",
    "progress.perfectScore": "Perfect 100%",
    "progress.answers": "Answers",
    "progress.keepStudying": "Keep studying to unlock achievements!",
    "progress.allUnlocked": "All achievements unlocked!",
    
    // Achievement Badges
    "badges.myBadges": "My Badges",
    "badges.loading": "Loading...",
    "badges.perfectScore": "Perfect 100%",
    "badges.perfectScoreDesc": "Get 100% on any level",
    "badges.streak3": "3 Day Streak",
    "badges.streak3Desc": "Study for 3 consecutive days",
    "badges.answers500": "500 Answers",
    "badges.answers500Desc": "Answer 500 questions total",
    "badges.keepStudyingUnlock": "Keep studying to unlock badges!",
    "badges.allUnlocked": "You unlocked all badges!",
    
    // Daily Concept
    "dailyConcept.seeMore": "See more",
    "dailyConcept.seeLess": "See less",
    
    // Continue Session
    "continueSession.noSessionYet": "No session to resume yet",
    "continueSession.startFirst": "Start your first study session!",
    "continueSession.startExam": "Start exam",
    "continueSession.goToModules": "Go to modules",

    // Subscription / Paywall
    "subscription.checking": "Checking subscription...",
    "subscription.requiredTitle": "PRO Subscription Required",
    "subscription.requiredDesc": "To access this feature you need an active PRO subscription",
    "subscription.benefitsTitle": "MBLearn PRO Benefits:",
    "subscription.benefit1": "Full access to all levels in all categories",
    "subscription.benefit2": "Unlimited MBLEx exam simulations (full 100-question exam mode)",
    "subscription.benefit3": "Review Bank: review your failed questions unlimited times",
    "subscription.benefit4": "All Study Cards (Flash Cards) unlocked",
    "subscription.benefit5": "Detailed progress tracking and personalized recommendations",
    "subscription.benefit6": "Continuous content updates",
    "subscription.activateAnnualPlan": "Activate Plan – from $14.99/month",
    "subscription.backToDashboard": "Back",
    "subscription.cancelAnytimeNoContracts": "Cancel anytime. No contracts.",

    // Institutional compliance
    "institutional.complianceBlocked": "Access blocked due to weekly non-compliance",
    "institutional.completeExamToUnlock": "Complete the weekly exam to unlock module practice.",
    "institutional.baselineRequired": "You must complete your Baseline exam first",
    "institutional.completeBaselineToUnlock": "Go to your dashboard to start the Baseline exam.",

    // TTS
    "tts.unavailable": "Audio feature is not available on this device.",
    "tts.audioVoice": "Audio Voice",
    "tts.selectVoice": "Select voice",
    "tts.chooseVoice": "Choose your preferred voice for reading questions.",
    "tts.readingSpeed": "Reading Speed",
    "tts.adjustSpeed": "Adjust the audio playback speed.",
    "tts.testVoice": "Test Voice",
    "tts.voiceTestText": "This is a voice test.",
    "tts.groupSpanish": "Spanish",
    "tts.groupEnglish": "English",
    "tts.groupOther": "Other",

    // Support
    "support.backHome": "Back to home",
    "support.title": "Support",
    "support.contactUs": "Contact Us",
    "support.contactDesc": "If you have questions or need help, please contact us at:",
    "support.responseTime": "Response Time",
    "support.responseTimeDesc": "We'll respond within 24–48 hours.",

    // Visual Anatomy
    "visualAnatomy.explanationHeader": "Explanation",
    "visualAnatomy.nextQuestion": "Next question",
    "visualAnatomy.finish": "Finish",
    "visualAnatomy.imageAlt": "Anatomical structure",
    "translation.missingNotice": "⚠️ Translation for this content is not available yet.",
    "translation.missingQuestion": "Question translation pending.",
    "translation.missingOptions": "Options translation pending.",
    "translation.missingExplanation": "Explanation translation pending.",

    // AI Tutor
    "ai.learnTitle": "Learn with MBLearn AI",
    "ai.learnSubtitle": "Understand the why in seconds",
    "ai.analyzing": "Analyzing your answer...",
    "ai.retry": "Retry",
    "ai.tutorLabel": "MBLearn AI Tutor",
    "ai.loadingExplanation": "Loading AI explanation...",
    "ai.viewTechnical": "View technical explanation",
    "ai.hideTechnical": "Hide technical explanation",
    "ai.noExplanationAvailable": "No explanation available",
    "ai.errorTooManyRequests": "Too many requests. Please wait a moment.",
    "ai.errorCreditsExhausted": "AI credits exhausted. Please try later.",
    "ai.noExplanationReceived": "No explanation received from AI",

    // Settings extra
    "settings.textSize": "Text Size",
    "settings.textSizeDescription": "Increase text size throughout the app for better readability.",
    "settings.motionEffects": "Motion Effects / Gyroscope",
    "settings.motionEffectsDescription": "Enable visual effects that respond to device tilt. Requires motion sensors.",
    "settings.motionNotSupported": "Your device does not support motion sensors.",
    "settings.motionPermissionDenied": "Motion permission denied. Enable it in your browser settings.",
    "settings.audio": "Audio",
    "settings.offline": "Offline",
    "settings.activeSessions": "Active Sessions",
    "settings.activeSessionsDesc": "Close all active sessions on Android devices for enhanced security",
    "settings.securityAction": "⚠️ Security Action",
    "settings.securityActionDesc": "This action will immediately close all active sessions on Android devices. Users will need to log in again.",
    "settings.terminatingSessions": "Terminating sessions...",
    "settings.closeAndroidSessions": "Close Android Sessions",
    "settings.androidSessionsTerminated": "{n} Android session(s) terminated successfully",
    "settings.androidSessionsTerminateError": "Error terminating Android sessions",
    "settings.deleteAccount": "Delete my account",
    "settings.deleteAccountDesc": "This action is permanent and irreversible. All your data, progress, subscription, and app access will be deleted.",
    "settings.deleteAccountWarning": "Are you sure you want to delete your account? This action cannot be undone.",
    "settings.deleteAccountConfirm": "Yes, delete my account",
    "settings.deleteAccountCancel": "Cancel",
    "settings.deletingAccount": "Deleting account...",
    "settings.deleteAccountSuccess": "Your account has been deleted successfully.",
    "settings.deleteAccountError": "Error deleting account. Please try again.",
    "settings.deleteAccountTypeConfirm": "Type DELETE to confirm",
    "settings.deleteAccountLegalNote": "Some minimal records may be retained for legal or audit requirements.",
    "settings.alreadyPaid": "Already made the payment?",
    "settings.alreadyPaidDesc": "If you already completed the payment on Stripe, click the button below to verify and activate your PRO subscription immediately.",
    "settings.verifyingPayment": "Verifying your payment...",
    "settings.verifyPaymentNow": "Verify my payment now",
    "settings.orSubscribe": "or subscribe now",
    "settings.priceDisplay": "from $14.99 / month",
    "settings.fullAccessContent": "Full access to all content",
    "settings.subscriptionRenewalNote": "The subscription renews automatically unless canceled 24 hours in advance. You can manage your subscription in the App Store.",
    "settings.year": "month",
    "settings.activateAnnualPlan": "Activate Plan – from $14.99/month",
    "settings.tryFreeLevel1": "Try free level 1",
    "settings.audioSettings": "Audio Settings",
    
    // Share Button
    "share.inviteFriend": "Invite a friend",
    "share.shareMBLearn": "Share MBLearn",
    
    // Safari Banner
    "safariBanner.message": "To install this app on your iPhone/iPad, you must use Safari. Please open this page in Safari to continue.",
    
    // Plan Badge
    "plan.unlockPro": "Unlock PRO",
    "plan.mustBeLoggedIn": "You must be logged in",
    "plan.checkoutError": "Error starting checkout",
    "plan.proAccessActive": "✅ Your PRO access is active",
    "plan.noActiveSubscription": "No active subscription found for this account",
    "plan.verifyError": "Error verifying subscription",
    "plan.bestValue": "Best value",
    "plan.mostFlexible": "Most flexible",
    "plan.save56": "Save 56%",
    "plan.save11": "Save 11%",
    "plan.equivalentMonthly": "equals $6.67/month",
    
    // Realistic Evaluation
    "evaluation.failingTopicsDetected": "Non-passing topics detected per MBLEx standard",
    "evaluation.topicsBelowThreshold": "You have {n} topic(s) scoring below 70%:",
    "evaluation.continueExam": "Continue exam",
    "evaluation.viewDiagnostic": "View diagnostic",
    "evaluation.mbLearnEvaluation": "MBLearn Evaluation",
    "evaluation.yourScore": "Your score:",
    "evaluation.recommendedMBLearn": "MBLearn recommended:",
    "evaluation.nonPassingTopics": "Non-passing topics (<70%):",
    "evaluation.more": "more",
    "evaluation.realisticEvaluation": "MBLearn Realistic Evaluation for MBLEx",
    "evaluation.overallScore": "Your overall score",
    "evaluation.nonPassingTopicsCount": "Non-passing topics ({n})",
    "evaluation.explainHasFailingEs": "The MBLEx requires a minimum of 70% to pass. The actual exam integrates questions from multiple topics into a single question. Taking the exam with non-passing topics significantly increases your risk of failing the real exam.",
    "evaluation.explainBelowRecommendedEs": "MBLearn recommends achieving at least {n}% before taking the real exam for greater confidence.",
    "evaluation.understoodContinue": "Understood, continue",
    "evaluation.mustAcknowledge": "You must acknowledge the evaluation before continuing",
    "evaluation.minimumRequired": "minimum of 70%",
    
    // useTTS labels
    "tts.question": "Question:",
    "tts.option": "Option",
    "tts.correctAnswer": "Correct answer:",
    "tts.explanation": "Explanation:",

    // Visual Anatomy Mode
    "visualAnatomy.title": "Visual Anatomy Practice",
    "visualAnatomy.description": "Choose a body system and recognize muscles, bones and structures in anatomical images. Answer and review the explanation to better reinforce the concept.",
    "visualAnatomy.selectSystem": "Select a system",
    "visualAnatomy.imagesAvailable": "{n} images available to practice",
    "visualAnatomy.startPractice": "Start practice",
    "visualAnatomy.noImagesYet": "No images available for this system yet",
    "visualAnatomy.imagesFromAdmin": "Images will be added from the admin panel",
    "visualAnatomy.selectToBegin": "Select a system to begin",
    "visualAnatomy.chooseAbove": "Choose one of the body systems above to practice visual anatomy",
    "visualAnatomy.feature1": "🎯 Real anatomical images with marked structures",
    "visualAnatomy.feature2": "🧠 Bilingual names: English (español)",
    "visualAnatomy.feature3": "📊 Detailed explanations after each question",
    "visualAnatomy.feature4": "✨ Progress saved for each system",
    "visualAnatomy.backToDashboard": "Back",
    
    // Question Version Selector
    "questionVersion.long": "Long Question",
    "questionVersion.short": "Short Question",
    
    // Share
    "share.linkCopied": "Link copied to clipboard",
    "share.linkCopyError": "Error copying link",
    
    // Topic Diagnostic
    "diagnostic.title": "Topic Diagnostic",
    "diagnostic.subtitle": "Identify exactly what you need to reinforce",
    "diagnostic.detailedAnalysis": "Detailed subtopic analysis",
    "diagnostic.current": "current",
    "diagnostic.topicsBelowRequired": "You have {n} topic(s) below the required 70%. Select a topic to see the subtopic breakdown.",
    "diagnostic.correct": "correct",
    "diagnostic.belowStandard": "below standard",
    "diagnostic.currentScore": "Current score",
    "diagnostic.needToPass": "You need at least 70% to pass this topic on the MBLEx",
    "diagnostic.noSubtopicData": "No subtopic data available. Practice more to get detailed diagnostics.",
    "diagnostic.subtopicsToReinforce": "Subtopics to reinforce:",
    "diagnostic.questionsFailed": "questions failed",
    "diagnostic.practice15": "Practice 15",
    "diagnostic.viewFailed": "View failed",
    "diagnostic.practiceAll": "Practice all",
    "diagnostic.backToExam": "Back to exam",
    
    // Dashboard toasts
    "toast.verifyingProSubscription": "Verifying your PRO subscription...",
    "toast.proAccessActive": "✅ Your PRO access is active! Enjoy all features.",
    "toast.noCompletedPayments": "No completed payments found",
    "toast.noCompletedPaymentsDesc": "If you just paid, wait a few minutes and try again in Settings → PRO",
    "toast.paymentProcessing": "Your payment is being processed...",
    "toast.verifyInSettings": "If payment was successful, go to Settings → PRO → 'Verify/Restore PRO'",
    
    // VerifyEmail
    "verifyEmail.title": "Verify your email",
    "verifyEmail.sentTo": "We have sent a verification email to:",
    "verifyEmail.followSteps": "Please follow these steps:",
    "verifyEmail.step1": "Open your inbox",
    "verifyEmail.step2": "Find the verification email",
    "verifyEmail.step3": "Click the verification link",
    "verifyEmail.step4": "Return to this page or sign in",
    "verifyEmail.checkSpam": "Check your spam folder if you don't see the email",
    "verifyEmail.resending": "Resending...",
    "verifyEmail.waitToResend": "Wait {n}s to resend",
    "verifyEmail.resendEmail": "Resend verification email",
    "verifyEmail.signOut": "Sign out",
    "verifyEmail.alreadyVerified": "Already verified your email?",
    "verifyEmail.refreshPage": "Refresh page",
    "verifyEmail.userEmailNotFound": "User email not found",
    "verifyEmail.emailResent": "Verification email resent successfully",
    "verifyEmail.errorResending": "Error resending email",
    
    // DailyStudyTip
    "studyTip.keyConcept": "Key Concept of the Day",
    
    // MBLEx Results Report
    "mblexReport.weeks": "weeks",
    
    // Therapy Application Modal
    "therapyApp.title": "Apply as Therapist",
    "therapyApp.subtitle": "Complete the form to join our network of professional therapists.",
    "therapyApp.fullName": "Full name",
    "therapyApp.email": "Email",
    "therapyApp.phone": "Phone",
    "therapyApp.state": "State where you live",
    "therapyApp.selectState": "Select state",
    "therapyApp.hasMassageLicense": "Do you have a massage license?",
    "therapyApp.isStudying": "Are you studying to get it?",
    "therapyApp.hasLymphaticCert": "Do you have lymphatic drainage certification?",
    "therapyApp.hasPostOpCert": "Do you have post-operative drainage certification?",
    "therapyApp.hasPreviousExp": "Do you have previous experience?",
    "therapyApp.expDetails": "Describe your experience",
    "therapyApp.uploadId": "Upload official ID",
    "therapyApp.uploadSelfie": "Upload selfie",
    "therapyApp.submit": "Submit application",
    "therapyApp.cancel": "Cancel",
    "therapyApp.uploading": "Uploading...",
    "therapyApp.uploaded": "Uploaded ✓",
    "therapyApp.submitting": "Submitting...",
    "therapyApp.successTitle": "Application submitted!",
    "therapyApp.successDesc": "Your application has been received. We will contact you soon.",
    "therapyApp.errorTitle": "Error",
    "therapyApp.errorDesc": "Could not submit application.",
    "therapyApp.requiredFields": "Required fields",
    "therapyApp.requiredFieldsDesc": "Please complete all required fields.",
    "therapyApp.uploadError": "Error uploading file.",
    
    // Admin Questions
    "admin.generateAnatomyImages": "Generate Visual Anatomy Images",
    "admin.anatomyImagesExclusive": "These images are exclusive for the Visual Anatomy Practice module",
    "admin.selectAnatomySystem": "Select the anatomical system",
    "admin.withImage": "with image",
    "admin.pending": "pending",
    "admin.panel": "Admin Panel",
    
    // Payment toasts
    "payment.verifying": "Verifying your payment...",
    "payment.verified": "Payment verified! You now have PRO access",
    "payment.failed": "Error verifying payment",
    "payment.noPaymentsFound": "No completed payments found",
    "payment.noPaymentsFoundDesc": "If you just paid, wait a few minutes and try again",
    "payment.processing": "Your payment is being processed...",
    
    // Auth additional
    "auth.accountCreatedVerifyEmail": "Account created. Please verify your email before continuing.",
    
    // Verify Email
    "verifyEmail.success": "Email verified successfully!",
    
    // Report
    "report.thanks": "✅ Thanks! Your report has been submitted.",
    "report.thanksDesc": "It helps us improve the content.",
    "report.failed": "Could not submit report",
    "report.failedDesc": "Try again later or contact support if the problem persists.",
    
    // Offline Content Manager
    "offline.managerTitle": "Offline Content",
    "offline.autoDownload": "The app automatically downloads the content you use so you can study offline",
    "offline.downloadAll": "Download All",
    "offline.clearCache": "Clear Cache",
    "offline.offlineMessage": "No connection. Connect to the internet to download more content.",
    "offline.savedQuestions": "Saved questions",
    "offline.pendingSync": "Pending sync",
    "offline.downloadingOffline": "Downloading content for offline use...",
    "offline.downloadingBtn": "Downloading...",
    "offline.downloadingProgress": "Downloading...",
    "offline.done": "Content downloaded successfully",
    "offline.doneDesc": "You can now use the app offline",
    "offline.downloadError": "Error downloading content",
    "offline.needConnection": "You need an internet connection to download content",
    "offline.cacheCleared": "Cache cleared successfully",
    "offline.cacheClearError": "Error clearing cache",
    "offline.downloadedCategories": "Downloaded categories:",
    "offline.autoDownloadLabel": "Auto download:",
    "offline.autoDownloadDesc": "When you study with internet, content is automatically saved for offline use. Use the \"Download All\" button only if you want everything available immediately.",
    "offline.initialDownloading": "Downloading initial content...",
    "offline.initialDownloadingDesc": "This may take a moment",
    "offline.initialDone": "Initial content downloaded",
    "offline.initialDoneDesc": "You can now use the app offline",
    "offline.initialError": "Error downloading initial content",
    "offline.initialRetry": "You can try again later from Settings",
    "adminUsers.noName": "No name",
    "adminUsers.noEmail": "No email",
    // Institution Dashboard
    "institution.unauthorized": "You don't have access to this institution dashboard",
    "institution.loadError": "Error loading cohort data",
    "institution.exportCSV": "Export CSV",
    "institution.exportSuccess": "Report exported successfully",
    "institution.exportError": "Error exporting the report",
    "institution.pilotEnded": "The pilot period has ended. Data is shown in read-only mode.",
    "institution.searchPlaceholder": "Search by name or email…",
    "institution.filterAll": "All",
    "institution.filterAtRisk": "At risk",
    "institution.filterInactive": "Inactive",
    "institution.filterActive": "Active",
    "institution.filterNoBaseline": "No baseline",
    "institution.filterLowAccuracy": "Low accuracy (<60%)",
    "institution.tabGlobal": "Global",
    "institution.tabStudents": "Students",
    "institution.totalStudents": "Total Students",
    "institution.active7d": "Active last 7 days",
    "institution.active30d": "Active last 30 days",
    "institution.avgAccuracy7d": "Avg Accuracy (7d)",
    "institution.avgAccuracy30d": "Avg Accuracy (30d)",
    "institution.totalTime30d": "Study Time (30d)",
    "institution.totalTimeUnavailable": "Not enough recorded time data.",
    "institution.realExams30d": "Exams (30d)",
    "institution.modulePractices30d": "Practices (30d)",
    "institution.participation30d": "Students with activity (30d)",
    "institution.participationShort": "Activity (30d)",
    "institution.accuracyShort30d": "Accuracy (30d)",
    "institution.accuracyShort7d": "Accuracy (7d)",
    "institution.accuracyCohort30d": "Cohort accuracy (30d)",
    "institution.accuracyCohort7d": "Cohort accuracy (7d)",
    "institution.accuracyLabel30d": "Accuracy (30d)",
    "institution.accuracyLabel7d": "Accuracy (7d)",
    "institution.cohortLabel": "Cohort:",
    "institution.activeLabel": "Active:",
    "institution.participationLabel": "Participation:",
    "institution.activeOnly": "Active",
     "institution.activeStudentsLabel": "active",
    "institution.tableMetric": "Metric",
    "institution.tableValue": "Value",
    "institution.tableContext": "Context",
    "institution.ofStudents": "of {count} students",
    "institution.activeStudents": "active",
    "institution.totalAttempts30d": "Questions answered (30d)",
    "institution.quizzesCompleted30d": "Sessions completed (30d)",
    "institution.basedOnActive7d": "Based on {count} active students (7 days)",
    "institution.basedOnActive30d": "Based on {count} active students (30 days)",
    "institution.basedOnTotal": "Of {count} cohort students",
    "institution.insufficientData": "Not enough data to calculate this metric yet.",
    "institution.sectionSummary": "Cohort Summary",
    "institution.sectionParticipation": "Participation",
    "institution.sectionProgress": "Academic Progress",
    "institution.sectionRisk": "Risk & Readiness",
    "institution.sectionAdvanced": "Advanced Detail",
    "institution.baselineCompleted": "Baseline completed",
    "institution.finalExamCompleted": "Final Exam completed",
    "institution.studentsAtRisk": "Students at risk",
    "institution.weakModules": "Weakest Modules",
    "institution.module": "Module",
    "institution.avgAccuracy": "Avg Accuracy",
    "institution.students": "Students",
    "institution.name": "Name",
    "institution.lastActivity": "Program Activity",
    "institution.lastGlobalActivity": "Last platform activity",
    "institution.accuracy": "Accuracy",
    "institution.attempts": "Exam / Practice",
    "institution.time": "Time",
    "institution.risk": "Risk",
    "institution.avgModuleAccuracy": "Avg Module Mastery",
    "institution.noStudents": "No students in this cohort",
    "institution.activationStatus": "Status",
    "institution.stagePending": "Not sent",
    "institution.stageInvited": "Invited",
    "institution.stageActivated": "Activated",
    "institution.stageConverted": "Existing account",
    "institution.stageActive": "Active",
    "institution.noActivityInProgram": "No activity in program",
    "institution.activityOutsideProgram": "Activity outside program",
    "institution.emailSent": "Email sent",
    "institution.accountActivated": "Account activated",
    "institution.cohortResults": "Academic Progress (Baseline vs Final Exam)",
    "institution.cohortResultsSample": "Calculated from {count} students with baseline and final exam completed",
    "institution.baselineAvg": "Baseline Average",
    "institution.finalExamAvg": "Final Exam Average",
    "institution.improvementAvg": "Avg Improvement (delta)",
    "institution.pctImproved": "Students Improved",
    "institution.readinessAvg": "Cohort Average Readiness",
    "institution.noExamDataYet": "No students with baseline and final exam completed yet to calculate this metric.",
    // Institution - Institutional Student Banner
    "institution.banner.baselineRequired": "Initial Academic Diagnosis Required",
    "institution.banner.baselineStep": "Step 1 of 1",
    "institution.banner.baselineDesc": "Before starting program levels, you must complete the Real Exam Mode (100 questions). This will be your diagnostic Baseline and will not affect your grade.",
    "institution.banner.programNotStarted": "Program hasn't started yet",
    "institution.banner.programNotStartedDesc": "Your cohort begins on {startDate}. Access to the Baseline and practices will be enabled automatically on that day. Get ready!",
    "institution.banner.baselineBtn": "Start Initial Diagnosis",
    "institution.banner.blockedTitle": "New Levels Blocked",
    "institution.banner.blockedDesc": "Last week's program requirements were not met ({levels}/2 levels · exam: {exam}). To unlock new levels, complete this week's Real Exam Mode.",
    "institution.banner.blockedBtn": "Catch Up – Weekly Exam",
    "institution.banner.weekTitle": "Week {week} of the Program",
    "institution.banner.finalWeekTitle": "Final Week – Closing Exam",
    "institution.banner.finalWeekBadge": "Final Week",
    "institution.banner.levelsCompleted": "Levels completed this week: {count}/{required}",
    "institution.banner.weeklyExam": "Weekly Exam (Real Exam Mode)",
    "institution.banner.finalExam": "Final Exam (Real Exam Mode)",
    "institution.banner.weeklyExamBtn": "Go to Weekly Exam",
    "institution.banner.finalExamBtn": "Go to Final Exam",
    "institution.banner.completeLevelsBtn": "Go to module practice",
    "institution.banner.weekCompleted": "Week completed! Keep going.",
    "institution.banner.programCompleted": "Final exam completed. Program finished!",
    "institution.status.nextProgramCompleted": "Program completed!",
    "institution.status.details": "View details",
    "institution.status.nextFinalExam": "Take final exam",
    "institution.banner.baseline": "Baseline: {score}% (obtained on {date})",
    "institution.status.title": "Program Status",
    "institution.status.baseline": "Baseline",
    "institution.status.weekly": "Weekly progress",
    "institution.status.levelsPassed": "Levels passed",
    "institution.status.nextStep": "Next step",
    "institution.status.pending": "Pending",
    "institution.status.upToDate": "Up to date",
    "institution.status.weeklyDetail": "Practice: {done}/{total} levels\nExam: {examStatus}",
    "institution.status.examDone": "completed",
    "institution.status.examPending": "pending",
    "institution.status.nextWaitStart": "Wait for program start",
    "institution.status.nextBaseline": "Complete initial Real Exam",
    "institution.status.nextCompliance": "Regularize pending weeks ({count}) — complete weekly exam",
    "institution.status.complianceStatus": "Status: pending weeks ({count})",
    "institution.status.complianceUpToDate": "Status: up to date",
    "institution.status.nextExam": "Complete weekly Real Exam",
    "institution.status.nextLevels": "Pass {remaining} more practice level(s)",
    "institution.status.nextFree": "Keep practicing!",
    "institution.journey.baseline": "Baseline",
    "institution.journey.weekly": "Weekly practice",
    "institution.journey.final": "Final exam",
    "institution.journey.end": "Done",
    "institution.status.totalAttempts": "Total attempts",
    "institution.status.avgScore": "Average",
    "institution.status.weekOf": "Week {current} of {total}",
    "institution.status.completed": "completed",
    "institution.status.thisWeek": "This week",
    "institution.status.milestones": "Milestones",
    "institution.status.performanceByLevel": "Performance by Level",
    "institution.status.levelAverage": "Level Average",
    "institution.status.subjectsAvg": "Subjects",
    "institution.status.realExamScore": "Real Exam",
    "institution.status.notAvailable": "Not available",
    "institution.status.inProgress": "In progress",
    "institution.status.practice": "Practice",
    "institution.status.exam": "Exam",
    "institution.status.levelsCount": "{done}/{total} levels",
    "institution.status.subjectsCount": "{done}/{total} subjects completed",
    "institution.status.examLocked": "Locked until {total}/{total} subjects are complete",
    "institution.status.examAvailable": "Available",
    "institution.status.examPassed": "Passed",
    "institution.status.currentLevel": "Current level",
    "institution.status.nextSubjects": "Complete the remaining {remaining} subjects in Level {level}",
    "institution.status.nextRealExamLevel": "Take the Level {level} Real Exam",
    "institution.status.nextStartLevel": "Start Level {level}",
    "institution.status.programDone": "Program completed!",
    "institution.status.baselineCompleted": "Completed",
    "institution.status.finalExam": "Final exam",
    "institution.status.programEnd": "Program end",
    "institution.detailed.title": "Detailed Progress",
    "institution.detailed.attempts": "attempts",
    "institution.detailed.totalAttempts": "Attempts",
    "institution.detailed.avgScore": "Average",
    "institution.detailed.passRate": "Pass rate",
    "institution.detailed.byCategory": "By category",
    "institution.detailed.levelsCompleted": "Levels completed",
    "institution.detailed.bestScore": "Best score",
    "institution.detailed.passedAttempts": "Passed",
    "institution.detailed.noData": "No activity recorded",
    "institution.detailed.loading": "Loading detail...",
    "institution.detailed.categoryHeader": "Category",
    "institution.detailed.attemptsShort": "Att.",
    "institution.detailed.levelHeader": "Level",
    "institution.detailed.avgShort": "Avg.",
    "institution.detailed.allLevelsComplete": "All levels completed",
    "institution.detailed.nextLevelHint": "Next: pass level {level} in Quiz with ≥70%",
    "institution.detailed.avgVisualHint": "Visual average — does not determine level unlock",
    "institution.detailed.inProgress": "In progress",
    "institution.detailed.noLevelsPassed": "No levels passed",
    "institution.detailed.progressionNote": "Level progression requires passing each level in Quiz mode with ≥70%. The average is for visual reference only.",
    // Institution - Improvement Card
    "institution.improvement.title": "Group Improvement from Baseline",
    "institution.improvement.noData": "No data yet (n=0)",
    "institution.improvement.noDataDesc": "Calculated when there are quiz attempts in the last 30 days.",
    "institution.improvement.initialAccuracy": "Initial Accuracy",
    "institution.improvement.initialTooltip": "Average accuracy during the first 7 days from the student's first attempt within the selected range.",
    "institution.improvement.first7days": "First 7 days",
    "institution.improvement.currentAccuracy": "Recent Accuracy",
    "institution.improvement.last30days": "Last 30 days",
    "institution.improvement.improvement": "Improvement",
    "institution.improvement.students": "n={count} students",
    "institution.improvement.singleStudent": "Based on 1 student with comparable data",
    // Institution - Category Performance Card
    "institution.category.title": "Performance by Category",
    "institution.category.days": "days",
    "institution.category.noData": "No data (n=0)",
    "institution.category.weakest": "Weakest",
    "institution.category.anatomy": "Anatomy & Physiology",
    "institution.category.kinesiology": "Kinesiology",
    "institution.category.pathology": "Pathology",
    "institution.category.ethics": "Ethics",
    "institution.category.business": "Business",
    "institution.category.assessment": "Assessment",
    "institution.category.treatment": "Treatment Planning",
    "institution.category.insufficientCategories": "Not enough categories with data to compare performance yet.",
    // Institution - Readiness Card
    "institution.readiness.title": "Active Students Readiness (30 days)",
    "institution.readiness.ready": "Ready for exam",
    "institution.readiness.onTrack": "On track",
    "institution.readiness.inProgress": "In progress",
    "institution.readiness.basedOn": "Based on n={count} active students (30 days)",
    "institution.readiness.noData": "n=0 — Requires active students",
    "institution.readiness.noDataTooltip": "Will show when students have attempts in the last 30 days.",
    "institution.readiness.singleStudentReady": "{count} of {total} active students is ready for exam",
    // MBLEx Readiness Score
    "readiness.title": "MBLEx Readiness Score",
    "readiness.ready": "Ready for MBLEx",
    "readiness.inProgress": "In progress",
    "readiness.atRisk": "At risk",
    "readiness.realExam": "Real Exam",
    "readiness.quizzes": "Quizzes",
    "readiness.compliance": "Compliance",
    "readiness.tooltip": "Combines your Real Exam average (70%), quizzes (20%), and weekly compliance (10%) to estimate your readiness.",
    "readiness.noRealExam": "Based on quizzes and compliance. Complete a Real Exam for more accuracy.",
    "readiness.cohortTitle": "MBLEx Readiness Score",
    "readiness.cohortBasedOn": "Based on {count} students",
    "readiness.cohortTooltip": "Will be calculated when students have activity.",
    // Institution - Accuracy Trend Chart
    "institution.trend.title": "Accuracy Trend",
    "institution.trend.days": "days",
    "institution.trend.noData": "Not enough activity data yet to show a trend.",
    "institution.trend.accuracy": "Accuracy",
    "institution.trend.questions": "Questions",
    // Institution - Risk badge
    "institution.riskHigh": "High",
    "institution.riskMedium": "Medium",
    "institution.riskLow": "Low",
    // Institution - Student Compliance
    "institution.compliance.title": "Weekly Compliance by Student",
    "institution.compliance.subtitle": "Weekly quota tracking: ≥{required} passed levels + 1 Real Exam",
    "institution.compliance.weekShort": "W",
    "institution.compliance.graceWeek": "Grace period — no compliance requirements",
    "institution.compliance.weekReq": "Required: ≥{required} levels + 1 Real Exam",
    "institution.compliance.rate": "Compliance",
    "institution.compliance.levels": "Levels",
    "institution.compliance.exam": "Exam",
    "institution.compliance.graceNote": "★ Marked weeks are grace periods (10% of cohort duration, min 1 day, max 7 days); formal compliance starts after.",
    "institution.tabCompliance": "Compliance",
    // Institution - Baseline vs Final (student)
    "institution.baselineVsFinal.title": "Your Progress: Baseline vs Latest Exam",
    "institution.baselineVsFinal.baseline": "Baseline",
    "institution.baselineVsFinal.finalExam": "Final Exam",
    "institution.baselineVsFinal.latest": "Latest Exam",
    "institution.baselineVsFinal.change": "Change",
    "institution.baselineVsFinal.improved": "You improved!",
    "institution.baselineVsFinal.declined": "Needs reinforcement",
    "institution.baselineVsFinal.noData": "Complete an exam",
    "institution.baselineVsFinal.pendingExam": "No exam after baseline yet",
    // Institution - Read-only / Post-cohort
    "institution.pilotEndedStudent": "The program has ended. Your dashboard is in read-only mode.",
    // Institution - Consolidated Report
    "institution.exportReport": "Export Pilot Report",
    "institution.reportExported": "Pilot report exported successfully",
    // Institution - Blocked practice (unblocked by completing the current week's Real Exam)
    "institution.blockedPractice": "Complete this week's Real Exam to unlock module practice",
    // Admin Cohorts
    "adminCohorts.title": "Cohort Management",
    "adminCohorts.newSchool": "New School",
    "adminCohorts.newCohort": "New Cohort",
    "adminCohorts.schoolName": "School Name",
    "adminCohorts.cohortName": "Cohort Name",
    "adminCohorts.selectSchool": "Select School",
    "adminCohorts.startDate": "Start Date",
    "adminCohorts.endDate": "End Date",
    "adminCohorts.importStudents": "Import Students",
    "adminCohorts.importDescription": "CSV with columns: first_name, last_name, email",
    "adminCohorts.viewDashboard": "View Dashboard",
    "adminCohorts.created": "Created successfully",
    "adminCohorts.importSuccess": "Students imported successfully",
    "adminCohorts.importError": "Error importing students",
    "adminCohorts.adminTitle": "Institutional Admin",
    "adminCohorts.createInstitution": "Create Institution",
    "adminCohorts.newInstitution": "New Institution",
    "adminCohorts.institutionName": "Institution name",
    "adminCohorts.institutionNamePlaceholder": "E.g.: Rockland Massage Academy",
    "adminCohorts.noInstitutions": "No institutions registered",
    "adminCohorts.noInstitutionsDesc": "Create your first institution to start managing cohorts and students.",
    "adminCohorts.institutions": "Institutions",
    "adminCohorts.colInstitution": "Institution",
    "adminCohorts.colStatus": "Status",
    "adminCohorts.colCohorts": "Cohorts",
    "adminCohorts.colStudents": "Students",
    "adminCohorts.colActivePilot": "Active pilot",
    "adminCohorts.viewCohorts": "View cohorts",
    "adminCohorts.yes": "Yes",
    "adminCohorts.no": "No",
    "adminCohorts.cohorts": "Cohorts",
    "adminCohorts.noCohorts": "No cohorts for this institution.",
    "adminCohorts.createFirstCohort": "Create first cohort",
    "adminCohorts.newCohortFor": "New Cohort",
    "adminCohorts.colName": "Name",
    "adminCohorts.colStart": "Start",
    "adminCohorts.colEnd": "End",
    "adminCohorts.colStudentsCount": "Students",
    "adminCohorts.statusActive": "Active",
    "adminCohorts.statusInactive": "Inactive",
    "adminCohorts.statusFinished": "Finished",
    "adminCohorts.statusDraft": "Draft",
    "adminCohorts.statusClosed": "Closed",
    "adminCohorts.statusArchived": "Archived",
    "adminCohorts.openDashboard": "Open Dashboard",
    "adminCohorts.deleteSchool": "Delete school",
    "adminCohorts.cohortLabel": "Cohort",
    "adminCohorts.selectCohort": "Select cohort",
    "adminCohorts.importing": "Importing...",
    "adminCohorts.createCohort": "Create Cohort",
    "adminCohorts.csvLabel": "CSV",
    "adminCohorts.sendAccess": "Send access",
    "adminCohorts.sendAccessTitle": "Send access to students",
    "adminCohorts.sendAccessDesc": "A password setup email will be sent to {count} students in cohort \"{cohort}\". Continue?",
    "adminCohorts.confirmSend": "Send",
    "adminCohorts.cancel": "Cancel",
    "adminCohorts.accessSent": "Access sent",
    "adminCohorts.accessResent": "Access resent successfully",
    "adminCohorts.resendAccess": "Resend access",
    "adminCohorts.removeStudentTitle": "Remove student",
    "adminCohorts.removeStudentDesc": "The student will be unlinked from this cohort. This does not delete their account.",
    "adminCohorts.confirmRemove": "Remove",
    "adminCohorts.studentRemoved": "Student removed from cohort",
    "adminCohorts.editCohort": "Edit cohort",
    "adminCohorts.editCohortTitle": "Edit Cohort",
    "adminCohorts.saveCohort": "Save changes",
    "adminCohorts.cohortUpdated": "Cohort updated successfully",
    "adminCohorts.minWeeklyLevels": "Required weekly levels",
    "adminCohorts.minWeeklyLevelsHint": "Minimum number of passed levels each student must complete per week to stay compliant.",
    "adminCohorts.archiveCohort": "Archive cohort",
    "adminCohorts.archiveCohortTitle": "Archive this cohort?",
    "adminCohorts.archiveCohortDesc": "The cohort will be marked as archived. Students won't be removed but the cohort will no longer be active.",
    "adminCohorts.confirmArchive": "Archive",
    "adminCohorts.cohortArchived": "Cohort archived",
    "adminCohorts.closeCohort": "Close cohort",
    "adminCohorts.closeCohortTitle": "Close this cohort?",
    "adminCohorts.closeCohortDesc": "The cohort will be marked as closed. The dashboard will remain available in read-only mode.",
    "adminCohorts.confirmClose": "Close",
    "adminCohorts.cohortClosed": "Cohort closed",
    "adminCohorts.duplicateCohort": "Duplicate cohort",
    "adminCohorts.cohortDuplicated": "Cohort duplicated successfully",
    "adminCohorts.manageStudents": "Manage students",
    "adminCohorts.actions": "Actions",
    "adminCohorts.cohortStatus": "Cohort status",
    "adminCohorts.activeCohortWarning": "There is already an active cohort in this school with {count} students. Would you like to edit it, duplicate it, or create a new one?",
    "adminCohorts.editExisting": "Edit existing",
    "adminCohorts.duplicateExisting": "Duplicate existing",
    "adminCohorts.createNew": "Create new",
    "adminCohorts.activate": "Activate cohort",
    "adminCohorts.cohortActivated": "Cohort activated",
    "adminCohorts.errorGeneric": "Error",
    "adminCohorts.errorLoadingStudents": "Error loading students",
    "adminCohorts.csvMinRows": "CSV must have header + at least 1 row",
    "adminCohorts.csvMissingEmail": "CSV must have an 'email' column",
    "adminCohorts.studentSingular": "student",
    "adminCohorts.studentPlural": "students",
    "adminCohorts.addStudent": "Add student",
    "adminCohorts.studentName": "Full name",
    "adminCohorts.studentEmail": "Email",
    "adminCohorts.addAndInvite": "Add & send invite",
    "adminCohorts.addStudentAction": "Add student",
    "adminCohorts.addStudentActionHint": "If the email already exists, it will be linked to the cohort without sending an invite.",
    "adminCohorts.adding": "Adding...",
    "adminCohorts.studentAdded": "Student added successfully",
    "adminCohorts.existingAccountLinked": "Existing account linked to cohort successfully",
    "adminCohorts.studentAddedAndInvited": "Student added and invitation sent",
    "adminCohorts.existingAccountLinkedAndNotified": "Existing account linked and notified successfully",
    "adminCohorts.invalidEmail": "Invalid email",
    "adminCohorts.copy": "copy",
    "adminCohorts.statusPending": "Pending",
    "adminCohorts.statusInvited": "Invited",
    "adminCohorts.statusActivated": "Activated",
    "adminCohorts.statusConverted": "Existing account",
    "adminCohorts.statusActiveStudent": "Active",
    "adminCohorts.lastActivity": "Last activity",
    "adminCohorts.never": "never",

    // Messages
    "messages.title": "Messages",
    "messages.sendMessage": "Send message",
    "messages.inbox": "Inbox",
    "messages.sentTab": "Sent",
    "messages.emptyInbox": "No messages yet",
    "messages.emptySent": "No sent messages",
    "messages.from": "From",
    "messages.to": "To",
    "messages.recipient": "Recipient",
    "messages.broadcast": "Announcement",
    "messages.backToInbox": "Back",
    "messages.reply": "Reply",
    "messages.sent": "Message sent",
    "messages.broadcastSent": "Message sent to group",
    "messages.fillAllFields": "Fill in subject and message",
    "messages.selectRecipient": "Select a recipient",
    "messages.subjectPlaceholder": "Subject",
    "messages.bodyPlaceholder": "Write your message...",
    "messages.cancel": "Cancel",
    "messages.sending": "Sending...",
    "messages.toUser": "User",
    "messages.toCohort": "Cohort",
    "messages.toSchool": "School",
    "messages.searchUser": "Search user...",
    "messages.selectCohort": "Select cohort",
    "messages.selectSchool": "Select school",
    "messages.archive": "Archive",
    "messages.archived": "Message archived",
    "messages.delete": "Delete",
    "messages.deleted": "Message deleted",
    "messages.read": "Read",
    "messages.unread": "Unread",
    "messages.readAt": "Read",
    "school.picker.title": "Select a school",
    "school.picker.subtitle": "Choose the school you want to manage.",
    "school.picker.enter": "Enter",
    "school.noSchools.title": "No schools assigned",
    "school.noSchools.body": "You don't have any schools linked to your account yet. Contact your administrator to get access.",
    "school.back": "Back",
    "school.changeSchool": "Change school",
    "school.quickAccess": "Quick access",
    "school.manageClasses": "Manage classes",
    "school.students": "Students",
    "school.studentsHint": "Manage students",
    "school.reports": "Reports",
    "school.cohorts": "Classes",
    "school.manage": "Manage",
    "school.noCohorts": "This school doesn't have any classes yet.",
    "school.stats.totalStudents": "Students",
    "school.stats.activeCohorts": "Active classes",
    "school.stats.closedCohorts": "Closed classes",
    "school.stats.inactive7d": "Inactive 7+ days",
    "school.stats.atRisk": "At risk",
    "school.stats.avgReadiness": "Ready ≥70%",
    "school.pendingActivation.title": "Your institution is pending activation",
    "school.pendingActivation.body": "Your request has been approved. Complete activation to begin managing students and cohorts.",
    "school.pendingActivation.cta": "Complete activation",
    "school.card.status": "Status",
    "school.card.plan": "Plan",
    "school.card.capacity": "Capacity",
    "school.card.capacityValue": "Up to {n} students",
    "school.card.price": "Price",
    "school.card.perYear": "/ year",
    "school.card.nextStep": "Next step",
    "school.locked": "Available after activating your institution.",
    "school.language": "Language",
    "adminCohorts.colPlan": "Plan",
    "adminCohorts.colCommercialStatus": "Commercial status",
    "adminCohorts.colSeats": "Seats",
    "adminCohorts.openInstitution": "Open institution",
    "license.title": "Institutional license",
    "license.plan": "Plan",
    "license.capacity": "Capacity",
    "license.capacityValue": "{n} students",
    "license.start": "Start",
    "license.validUntil": "Valid until",
    "license.seats": "Seats",
    "license.status": "Status",
    "license.status.active": "Active",
    "license.status.expiring": "Expiring soon",
    "license.status.expired": "Expired",
    "license.status.notActivated": "Not activated",
    "license.expiringNotice": "Your institutional license expires on {date}.",
    "license.expiredTitle": "Institutional license expired",
    "license.expiredBody": "Renew your license to manage students and classes again. Your data and academic history are preserved.",
    "license.renewSoon": "Renewal will be available here.",
    "license.readOnly": "Read-only mode: you can review existing students and classes.",
    "license.blockedToast": "This institution is not active. Academic operations are locked until activation.",
    "license.expiredToast": "This institution's license expired. Renew it to manage students and classes.",
    "institution.withdrawStudent": "Remove from institution",
    "institution.withdrawStudentDesc": "The student's institutional enrollment ends and the seat is released. Their MBLearn account, progress and academic history are preserved.",
  } as const;

export default dict;
export type EnKeys = keyof typeof dict;
